<template>
    <v-card flat>
        <!-- SEARCH TEXT CARD -->
        <v-card flat style="width:500px;height:130px;margin:auto;margin-top:10px" color="white">
            <!-- <v-btn small text icon @click="speak()">
                <v-icon color="primary" v-if="hasContextPanel(item)">mdi-eye-settings</v-icon>
                <v-icon color="gray" v-else>mdi-eye-settings</v-icon>
            </v-btn> -->
            <!--            <v-img
                            src="https://valesco.es/sites/default/files/logo_web_4.png"
                            height="200px"
                            ></v-img>-->

            <v-container style="overflow: hidden" class="pa-0">
                <v-row class="pa-0 ma-0" justify="center">
                    <v-col cols="10" align-self="center">
                        <v-text-field v-if="debugTextSearch" id="regexInput" class="mb-2" v-model="search_regex"
                            label="Regex expression" @keydown.enter="doSearch" height="35" solo rounded
                            hide-details="true" value="">
                        </v-text-field>
                        <v-text-field class="mb-2" v-model="search_words" label="Buscar palabras"
                            @keydown.enter="doSearch"
                            hint="Escriba las palabras que desea buscar separadas por espacios. Separe las palabras con (|) para indicar opcionalidad. Utilice (?) para indicar que la palabra buscada puede tener cualquier carácter de palabra en esa posición. Utilice (*) para obtener cualquier sucesión de caracteres de palabra."
                            height="35" solo rounded>
                            <template v-slot:prepend-inner>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="doSearch">search</v-icon>
                                    </template>
                                    "Buscar estas palabras en las conversaciones"
                                </v-tooltip>
                            </template>
                            <template v-slot:append>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="search_words = ''">close</v-icon>
                                    </template>
                                    "Borrar texto"
                                </v-tooltip>
                            </template>

                            <v-icon slot="append" @click="search_words = ''">
                                close
                            </v-icon>
                        </v-text-field>
                    </v-col>
                    <v-col class="" align-self="start" cols="2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-6" v-on="on" @click.stop="filters_dialog = true">
                                    <v-icon color="black">mdi-filter-cog</v-icon>
                                </v-btn>
                            </template>
                            "Definir filtros de búsqueda"
                        </v-tooltip>
                        <v-dialog v-model="filters_dialog" max-width="650">
                            <!-- FILTERS SECTION -->
                            <v-container class="pa-0" fluid>
                                <!--style="width:650px"-->
                                <v-row no-gutters justify="center">
                                    <v-col cols="12" class="pa-0">
                                        <v-card class="pa-5 filter-color">
                                            <v-card-title class="filter-color py-0" style="min-height:10px" hide-actions
                                                dense>
                                                <h3 class="filter-color font-weight-bold text-center"
                                                    style="line-height:10px">
                                                    Opciones de búsqueda
                                                </h3>
                                            </v-card-title>

                                            <v-card-text class="filter-color pa-0 ma-0"
                                                style="padding:0px !important;font-size:90%">
                                                <v-toolbar class="filter-color" dense flat>
                                                    <v-tabs v-model="selected_entity_tab" height="35">
                                                        <v-tab v-for="searchFilter in search_filters"
                                                            :key="searchFilter['id']"
                                                            :href="'#tab-' + searchFilter['id']" small class="px-2"
                                                            dense>
                                                            <v-icon dense left>{{ searchFilter.icon }}</v-icon>
                                                            {{ searchFilter.name }}
                                                        </v-tab>
                                                    </v-tabs>
                                                </v-toolbar>

                                                <v-tabs-items v-model="selected_entity_tab">
                                                    <v-tab-item v-for="searchFilter in search_filters"
                                                        :key="searchFilter['id']" :value="'tab-' + searchFilter['id']">

                                                        <!-- OPTIONS SECTION -->
                                                        <v-container v-if="searchFilter['id'] === 'options'"
                                                            class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-0 mb-2 pa-1" outlined>
                                                                <v-row no-gutters>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Buscar por
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['token_mode']"
                                                                            dense mandatory>
                                                                            <v-btn color="white" :value="'shape'" small>
                                                                                Forma
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'lemma'" small>
                                                                                Lema
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        considerar
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['capital_mode']"
                                                                            dense>
                                                                            <v-btn color="white" :value="'uppercase'"
                                                                                small>
                                                                                Mayúsculas
                                                                            </v-btn>
                                                                            <!--                                                            <v-btn
                                                                                                                                            color="white"  
                                                                                                                                            :value="'lowercase'"
                                                                                                                                            small>
                                                                                                                                            Minúsculas
                                                                                                                                        </v-btn>-->
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        /
                                                                    </v-col>
                                                                    <v-col class="search-value-col px-0" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['accents']"
                                                                            dense>
                                                                            <v-btn color="white" :value="'accents'"
                                                                                small>
                                                                                Acentos
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color mb-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Aparece
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['filter_position']"
                                                                            dense>
                                                                            <v-btn color="white" :value="'preceded'"
                                                                                small>
                                                                                <!--<v-icon>mdi-format-align-center</v-icon>-->
                                                                                Precedido
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'followed'"
                                                                                small>
                                                                                <!--<v-icon>mdi-format-align-left</v-icon>-->
                                                                                Seguido
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'both'" small>
                                                                                <!--<v-icon>mdi-format-align-left</v-icon>-->
                                                                                ambos
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        por
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-btn-toggle
                                                                            v-model="filterForm['options']['filter_position_char']"
                                                                            dense>
                                                                            <v-btn color="white"
                                                                                :value="'exclamation_mark'" small>
                                                                                !¡
                                                                            </v-btn>
                                                                            <v-btn color="white"
                                                                                :value="'question_marks'" small>
                                                                                ¿?
                                                                            </v-btn>
                                                                            <v-btn color="white" :value="'slash'" small>
                                                                                /
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color mb-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <v-col cols="12">
                                                                        Clase de palabra
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['word_type']"
                                                                            :items="word_types" dense solo outlined
                                                                            hide-details="true"
                                                                            @change="resetWordTypeSection()"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isPronomTypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete v-model="c"
                                                                            :items="pronom_types" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isDetTypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['type']"
                                                                            :items="det_types" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isSustTypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['type']"
                                                                            :items="sust_types" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isPronomSubtypeVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Subtipo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['word_type']"
                                                                            :items="pronom_subtypes" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isPersonVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Persona
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['person']"
                                                                            :items="persons" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isGenreVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Género
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['genre']"
                                                                            :value="filterForm['options']['genre']"
                                                                            :items="genres" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isNumberVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Número
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['number']"
                                                                            :items="numbers" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isMoodVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Modo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['mood']"
                                                                            :items="moods" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row v-if="isTenseVisible()" no-gutters>
                                                                    <v-col cols="12">
                                                                        Tiempo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['options']['tense']"
                                                                            :items="tenses" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>

                                                        <!-- METADATA SECTION -->
                                                        <v-container v-if="searchFilter['id'] === 'metadata'"
                                                            class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <!--{{conversations}}-->
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Buscar en conversación
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['metadata']['conversation']"
                                                                            :items="conversations" item-text="name"
                                                                            item-value="cod" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters>
                                                                    <!--{{conversations}}-->
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Tipo de conversación
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-autocomplete
                                                                            v-model="filterForm['metadata']['conversation_type']"
                                                                            :items="conversation_types" item-text="name"
                                                                            item-value="cod" dense solo outlined
                                                                            hide-details="true"></v-autocomplete>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Buscar entre los años
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="2">
                                                                        <v-text-field
                                                                            v-model="filterForm['metadata']['conv_year_init']"
                                                                            outlined class="filterForm-input"
                                                                            hide-details="true" dense solo>
                                                                        </v-text-field>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        y
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="2">
                                                                        <v-text-field
                                                                            v-model="filterForm['metadata']['conv_year_end']"
                                                                            outlined hide-details="true" solo dense>
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-label-col" cols="12">
                                                                        Buscar hablante
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Género
                                                                    </v-col>
                                                                    <v-col cols="2" class="search-value-col mr-2">
                                                                        <v-radio-group class="mt-0"
                                                                            v-model="filterForm['metadata']['speaker_genre']"
                                                                            hide-details="true" color="purple" row
                                                                            dense>
                                                                            <v-radio style="" dense label="Hombre"
                                                                                value="H">
                                                                            </v-radio>
                                                                            <v-radio label="Mujer" value="M">
                                                                            </v-radio>
                                                                        </v-radio-group>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Nivel educativo
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox
                                                                            v-model="filterForm['metadata']['speaker_educational_level']"
                                                                            :items="educational_levels" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                    <v-spacer></v-spacer>
                                                                </v-row>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Edad
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox class="mr-3"
                                                                            v-model="filterForm['metadata']['speaker_age_range']"
                                                                            :items="age_ranges" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                    <v-col class="search-label-col" cols="auto">
                                                                        Edad 2
                                                                    </v-col>
                                                                    <v-col class="search-value-col" cols="3">
                                                                        <v-combobox
                                                                            v-model="filterForm['metadata']['speaker_age_range_2']"
                                                                            :items="age_ranges_2" item-value="cod"
                                                                            item-text="name" outlined dense
                                                                            hide-details="true" solo>
                                                                        </v-combobox>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>

                                                        <!--UNITS SECTION-->
                                                        <v-container v-if="searchFilter['id'] === 'units'"
                                                            class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters justify="start">
                                                                    <!--                                                                    <v-col
                                                                                                                                            class="search-value-col mr-12"
                                                                                                                                            cols="auto"
                                                                                                                                            >  
                                                                                                                                            <v-checkbox dense hide-details="true" v-model="filterForm['units']['speeches']" label="Discursos"></v-checkbox>
                                                                                                                                            <v-checkbox dense hide-details="true" v-model="filterForm['units']['dialogs']" label="Diálogos"></v-checkbox>
                                                                                                                                            <v-checkbox dense hide-details="true" v-model="filterForm['units']['interventions']" label="Intervenciones"></v-checkbox>
                                                                                                                                            <v-checkbox dense hide-details="true" v-model="filterForm['units']['turns']" label="Turnos"></v-checkbox>
                                                                                                                                            <v-checkbox dense hide-details="true" v-model="filterForm['units']['acts']" label="Actos"></v-checkbox>
                                                                                                                                        </v-col>-->
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-row no-gutters justify="start">
                                                                            <v-col cols="12">
                                                                                Tipo de subacto
                                                                            </v-col>
                                                                            <v-col cols="auto" class="ml-6">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSD']"
                                                                                    label="SSD"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSS']"
                                                                                    label="SSS"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSTop']"
                                                                                    label="SSTop"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSSX']"
                                                                                    label="SSX"></v-checkbox>
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAT']"
                                                                                    label="SAT"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAT_M']"
                                                                                    label="SAT/M"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAT_I']"
                                                                                    label="SAT/I"></v-checkbox>
                                                                                <!--                                                                                ----
                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['units']['subactsSS_SSA']" label="SS/SA"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['units']['subactsSAX']" label="SAX"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['units']['residue']" label="Residuo"></v-checkbox>-->
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAM']"
                                                                                    label="SAM"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAM_T']"
                                                                                    label="SAM/T"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAM_I']"
                                                                                    label="SAM/I"></v-checkbox>
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAI']"
                                                                                    label="SAI"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAI_T']"
                                                                                    label="SAI/T"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAI_M']"
                                                                                    label="SAI/M"></v-checkbox>
                                                                            </v-col>
                                                                            <v-col cols="auto ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSS_SSA']"
                                                                                    label="SS/SA"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['subactsSAX']"
                                                                                    label="SAX"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['residue']"
                                                                                    label="Residuo"></v-checkbox>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col class="search-value-col" cols="auto">
                                                                        <v-row no-gutters justify="start">
                                                                            <v-col cols="12">
                                                                                Tipo de intervención
                                                                            </v-col>
                                                                            <v-col cols="auto" class="ml-10">
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['initiative']"
                                                                                    label="Iniciativa"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['independent']"
                                                                                    label="Independiente"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['reactive']"
                                                                                    label="Reactiva"></v-checkbox>
                                                                                <v-checkbox dense hide-details="true"
                                                                                    v-model="filterForm['units']['reactive_initiative']"
                                                                                    label="Reactivo-iniciativa"></v-checkbox>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>

                                                        <!--PROSODY SECTION-->
                                                        <v-container v-if="searchFilter['id'] === 'prosody'" fluid
                                                            class="filter-color pa-0">
                                                            <!--                                                            <v-card 
                                                                                                                            outlined
                                                                                                                            class="filter-row-color my-3 search-value-col"
                                                                                                                            >
                                                                                                                            <v-col
                                                                                                                                cols="12">  
                                                                                                                                <v-checkbox dense hide-details="true" v-model="filterForm['prosody']['annotation']" label="Grupo entonativo"></v-checkbox>
                                                                                                                            </v-col>
                                                                                                                        </v-card>-->
                                                            <v-card outlined class="filter-row-color my-3 pa-1">
                                                                <v-col class="search-label-col" cols="12">
                                                                    Inflexión final
                                                                </v-col>
                                                                <v-row no-gutters justify="start">
                                                                    <v-col cols="auto" class="ml-10"
                                                                        style="padding:0px !important">
                                                                        <v-checkbox dense hide-details="true"
                                                                            v-model="filterForm['prosody']['tone_ascending']"
                                                                            label="Ascendente"></v-checkbox>
                                                                        <v-checkbox dense hide-details="true"
                                                                            v-model="filterForm['prosody']['tone_descending']"
                                                                            label="Descendente"></v-checkbox>
                                                                    </v-col>
                                                                    <v-col cols="auto" class="ml-10"
                                                                        style="padding:0px !important">
                                                                        <v-checkbox dense hide-details="true"
                                                                            v-model="filterForm['prosody']['tone_suspended']"
                                                                            label="Suspendido"></v-checkbox>
                                                                        <v-checkbox dense hide-details="true"
                                                                            v-model="filterForm['prosody']['tone_circumflex']"
                                                                            label="Circunflejo"></v-checkbox>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>
                                                    </v-tab-item>
                                                </v-tabs-items>

                                                <v-row no-gutters justify="end">
                                                    <v-col cols="auto">
                                                        <v-btn class="mr-3" color="white"
                                                            @click="doSearch(); filters_dialog = false;" small>
                                                            Filtrar
                                                        </v-btn>
                                                        <v-btn class="mr-3" color="white"
                                                            @click="resetFilterSection(selected_entity_tab.replace('tab-', ''));"
                                                            small>
                                                            Borrar
                                                        </v-btn>
                                                        <v-btn class="mr-3" color="white"
                                                            @click="filters_dialog = false;" small>
                                                            Cerrar
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-dialog>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <!-- {{ filterForm }} -->
        <!-- SEARCH RESULTS SECTION -->
        <v-container v-if="search_text && search_text.length > 0 && currentFilter">
            <v-row justify="start">
                <v-col class="pa-0 pl-3 pr-3">
                    <v-expansion-panels>
                        <v-expansion-panel id="filter-summary-panel" class="mb-2">
                            <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                                <v-toolbar class="expand-panel-header-custom" dense dark>
                                    <v-app-bar-nav-icon></v-app-bar-nav-icon>

                                    <v-toolbar-title>Resumen de filtros</v-toolbar-title>

                                    <v-spacer></v-spacer>

                                    <v-btn icon>
                                        <v-icon>mdi-filter-multiple</v-icon>
                                    </v-btn>
                                </v-toolbar>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content class="filter-color pt-4">
                                <!-- <v-card id="filter-summary-panel" class="item-card pa-3"
                                    style="margin-bottom:0 !important"> -->
                                <v-row no-gutters justify="start">
                                    <v-col cols="auto" v-html="currentFilter">
                                    </v-col>
                                </v-row>
                                <!-- </v-card> -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>

            <v-row justify="start">
                <v-col :cols="result_card_cols" class="pa-3">
                    <!--style="width:70%"-->
                    <!-- RESULT SECTION -->
                    <v-card id="resultsCard" class="item-card">
                        <v-card outlined class="filter-row-color my-3 pa-1">
                            <v-row no-gutters justify="start">
                                <v-col v-if="!loading_results" class="pa-1 pt-2" cols="auto">
                                    Encontradas {{ result_tokens_count }} ocurrencias al buscar por <span
                                        style="color: darkorchid">"{{ search_text }}"</span>
                                    <!-- Encontradas {{ result_tokens_count }} ocurrencias en {{ interventionsTotalCount }}
                                    intervenciones en {{ result_conversation_count }} conversaciones al buscar por <span
                                        style="color: darkorchid">"{{ search_text }}"</span> -->
                                </v-col>
                                <v-col v-if="loading_results" class="pa-1 pt-2" cols="auto">
                                    Buscando en el corpus...
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col v-if="selected_rows.length > 0" class="pa-1" cols="auto">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                @click="generateResultDoc(selected_rows)">mdi-file-word</v-icon>
                                        </template>
                                        "Descargar resultados seleccionados en word"
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="selected_rows.length > 0" class="pa-1" cols="auto">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                @click="generateResultExcel(selected_rows)">mdi-file-excel</v-icon>
                                        </template>
                                        "Descargar resultados seleccionados en excel"
                                    </v-tooltip>
                                </v-col>
                                <v-btn icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                @click="visualization_dialog = true">mdi-eye-settings</v-icon>
                                        </template>
                                        "Opciones de visualización"
                                    </v-tooltip>
                                </v-btn>

                                <v-dialog v-model="visualization_dialog" max-width="475">
                                    <!-- FILTERS SECTION -->
                                    <v-container class="pa-0" fluid>
                                        <!--style="width:650px"-->
                                        <v-row no-gutters justify="center">
                                            <v-col cols="12" class="pa-0">
                                                <v-card class="pa-5 filter-color">
                                                    <v-card-title class="filter-color py-0" style="min-height:10px"
                                                        hide-actions dense>
                                                        <h3 class="filter-color font-weight-bold text-center"
                                                            style="line-height:10px">
                                                            Opciones de visualización
                                                        </h3>
                                                    </v-card-title>

                                                    <v-card-text class="filter-color pa-0 ma-0"
                                                        style="padding:0px !important;font-size:90%">
                                                        <!--UNITS VISUALIZATION SECTION-->
                                                        <v-container class="filter-color pa-0" fluid>
                                                            <v-card class="filter-row-color my-3 search-value-col"
                                                                outlined>
                                                                <v-row no-gutters justify="start">
                                                                    <v-row no-gutters justify="start">
                                                                        <v-col class="search-value-col mr-12"
                                                                            cols="auto">
                                                                            <v-checkbox dense hide-details="true"
                                                                                v-model="visualizationForm['units']['speeches']"
                                                                                label="Discursos"></v-checkbox>
                                                                            <v-checkbox dense hide-details="true"
                                                                                v-model="visualizationForm['units']['dialogs']"
                                                                                label="Diálogos"></v-checkbox>
                                                                            <v-checkbox dense hide-details="true"
                                                                                v-model="visualizationForm['units']['interventions']"
                                                                                label="Intervenciones"></v-checkbox>
                                                                        </v-col>
                                                                        <v-col class="search-value-col mr-12"
                                                                            cols="auto">
                                                                            <!--<v-checkbox dense hide-details="true" v-model="visualizationForm['units']['turns']" label="Turnos"></v-checkbox>-->
                                                                            <v-checkbox dense hide-details="true"
                                                                                v-model="visualizationForm['units']['acts']"
                                                                                label="Actos"></v-checkbox>
                                                                            <v-checkbox dense hide-details="true"
                                                                                v-model="visualizationForm['units']['subacts']"
                                                                                label="Subactos"></v-checkbox>
                                                                            <v-checkbox dense hide-details="true"
                                                                                v-model="visualizationForm['units']['token_morphologies']"
                                                                                label="Morfologías de palabra"></v-checkbox>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-row>
                                                            </v-card>
                                                        </v-container>

                                                        <v-row no-gutters justify="end">
                                                            <v-col cols="auto">
                                                                <v-btn class="mr-3" color="white"
                                                                    @click="doSearch(); visualization_dialog = false;"
                                                                    small>
                                                                    Filtrar
                                                                </v-btn>
                                                                <v-btn class="mr-3" color="white"
                                                                    @click="resetVisualizationSection();" small>
                                                                    Borrar
                                                                </v-btn>
                                                                <v-btn class="mr-3" color="white"
                                                                    @click="visualization_dialog = false;" small>
                                                                    Cerrar
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-dialog>
                            </v-row>
                        </v-card>

                        <!-- RESULT DATA TABLE -->
                        <v-data-table class="transparent elevation-2" item-key="cod" v-model="selected_rows"
                            :headers="filtered_result_headers" :items="result_items" :items-per-page="10" locale="es-ES"
                            :expanded.sync="expanded" single-expand @item-expanded="loadInterventionDetails" show-select
                            :loading="loading_results" loading-text="Cargando datos..." :options.sync="options"
                            :server-items-length="interventionsTotalCount"
                            no-data-text="No se han encontrado resultados" dense :footer-props="{
                                itemsPerPageOptions: [10, 20, 30],
                                'items-per-page-text': 'Intervenciones por página'
                            }">

                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                <tr :id="'row_' + item['cod']"
                                    :class="item['is_observation'] ? 'observation' : item.is_direct_speech ? 'directSpeech' : ''"
                                    :key="item.cod">
                                    <!--@click="checkSelected(item)"-->
                                    <td class="text-start check-search"
                                        style="width:1px;min-width:1px;padding: 0 12px;">
                                        <v-checkbox v-model="selected_rows" :value="item" style="margin:0px;padding:0px"
                                            hide-details @change="checkSelected(item)"></v-checkbox>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-btn small text icon @click="expand(!isExpanded)">
                                            <v-icon color="primary" v-if="isExpanded">mdi-chevron-down</v-icon>
                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                        </v-btn>
                                    </td>
                                    <td v-show="$env.type != 'PRODUCTION'" class="text-center">
                                        {{ item.cod }}
                                    </td>
                                    <td class="text-center">
                                        {{ item["conversation"]["name"] }}
                                    </td>
                                    <td class="text-center">
                                        {{ item["intervention_type"] }}
                                    </td>
                                    <td style="font-family: monospace !important;" class="text-center"
                                        v-html="item.conversation_speaker">
                                    </td>
                                    <!--                                <td class="text-left">
                                                                    {{item["cod"]}}
                                                                </td>-->
                                    <td class="text-left">
                                        <span v-if="debugTextSearch">*{{ item["cod"] }}*</span>
                                        <div class="interv-contents" v-html="highlight(item)">
                                        </div>
                                        <span v-if="debugTextSearch">*{{ item["search_data"] ?
                                            item["search_data"]["tokens_parsed"].toString() : "" }}*</span>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-btn icon @click="loadContextPanel(item)">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-if="hasContextPanel(item)" v-on="on"
                                                        color="primary">mdi-invoice-text-multiple-outline</v-icon>
                                                    <v-icon v-on="on" color="gray"
                                                        v-else>mdi-invoice-text-multiple-outline</v-icon>
                                                </template>
                                                "Mostrar contexto de intervención"
                                            </v-tooltip>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <!--                            <template v-slot:header.data-table-select="{ on, props }">
                                                            <v-simple-checkbox color="red" v-bind="props" v-on="on">
                            
                                                            </v-simple-checkbox>
                                                        </template>
                                                        <template v-slot:item.data-table-select="{ on, props }">
                                                            <v-simple-checkbox color="green" v-bind="props" v-on="on">
                            
                                                            </v-simple-checkbox>
                                                        </template>-->

                            <template v-slot:expanded-item="{ headers, item }">
                                <td style="padding:0" :colspan="headers.length">
                                    <v-card v-if="item" width="100%" height="60">
                                        <!--More info about {{ item.cod }}--asdfasd-->
                                        <v-container justify-center grid-list-xl fluid>
                                            <v-layout row wrap>
                                                <v-flex class="row-padding" xs12>
                                                    <v-row no-gutters justify="center">
                                                        <v-col cols="auto">
                                                            <v-row no-gutters justify="center">
                                                                <loading-wheel v-if="audio_is_loading"></loading-wheel>
                                                                <div :id="'plyr_inter_' + item['cod']">
                                                                    <audio id="audio_player">
                                                                    </audio>
                                                                </div>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card>
                                </td>
                            </template>

                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{ items.pageStop }}
                                de
                                {{ interventionsTotalCount }} </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <v-col :cols="detail_card_cols" class="pa-3">
                    <!--style="width:30%"-->
                    <!-- CONTEXT DETAILS -->
                    <v-card id="contextCard" class="item-card" v-show="detail_items && result_card_cols === 7">
                        <v-container fluid class="filter-color pa-0">
                            <v-card outlined class="filter-row-color my-3 pa-1">
                                <v-row no-gutters justify="end">
                                    <v-col class="pa-1 pt-2" cols="auto">
                                        Ampliar contexto en
                                    </v-col>
                                    <v-col class="mt-2" cols="1">
                                        <v-text-field v-model="context_ratio" outlined hide-details="true"
                                            @keydown.enter="loadInterventionContextGrid" solo dense>
                                        </v-text-field>
                                    </v-col>
                                    <v-col class="pa-1 pt-2" cols="auto">
                                        intervenciones
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col class="mr-auto pl-2" cols="auto">
                                        <v-row no-gutters justify="start">
                                            <v-col
                                                v-if="itemWithSelectedContext && itemWithSelectedContext['conversation']['is_segmented']"
                                                class="pa-1 pt-1" cols="auto">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on"
                                                            @click="context_visualization_dialog = true">mdi-eye-settings</v-icon>
                                                    </template>
                                                    "Opciones de visualización"
                                                </v-tooltip>
                                            </v-col>
                                            <v-dialog v-model="context_visualization_dialog" max-width="650">
                                                <!-- FILTERS SECTION -->
                                                <v-container class="pa-0" fluid>
                                                    <!--style="width:650px"-->
                                                    <v-row no-gutters justify="center">
                                                        <v-col cols="12" class="pa-0">
                                                            <v-card class="pa-5 filter-color">
                                                                <v-card-title class="filter-color py-0"
                                                                    style="min-height:10px" hide-actions dense>
                                                                    <h3 class="filter-color font-weight-bold text-center"
                                                                        style="line-height:10px">
                                                                        Opciones de visualización
                                                                    </h3>
                                                                </v-card-title>

                                                                <v-card-text class="filter-color pa-0 ma-0"
                                                                    style="padding:0px !important;font-size:90%">
                                                                    <!--UNITS VISUALIZATION SECTION-->
                                                                    <v-container v-if="itemWithSelectedContext"
                                                                        class="filter-color pa-0" fluid>
                                                                        <v-card
                                                                            class="filter-row-color my-3 search-value-col"
                                                                            outlined>
                                                                            <v-row no-gutters justify="start">
                                                                                <v-col class="search-value-col mr-12"
                                                                                    cols="auto">
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['conversation']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="contextVisualizationForm['units']['speeches']"
                                                                                        label="Discursos"></v-checkbox>
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['conversation']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="contextVisualizationForm['units']['dialogs']"
                                                                                        label="Diálogos"></v-checkbox>
                                                                                    <v-checkbox dense
                                                                                        hide-details="true"
                                                                                        v-model="contextVisualizationForm['units']['interventions']"
                                                                                        label="Intervenciones"></v-checkbox>
                                                                                </v-col>
                                                                                <v-col class="search-value-col mr-12"
                                                                                    cols="auto">
                                                                                    <!--<v-checkbox dense hide-details="true" v-model="contextVisualizationForm['units']['turns']" label="Turnos"></v-checkbox>-->
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['conversation']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="contextVisualizationForm['units']['acts']"
                                                                                        label="Actos"></v-checkbox>
                                                                                    <v-checkbox
                                                                                        v-if="itemWithSelectedContext['conversation']['is_segmented']"
                                                                                        dense hide-details="true"
                                                                                        v-model="contextVisualizationForm['units']['subacts']"
                                                                                        label="Subacts"></v-checkbox>
                                                                                    <v-checkbox dense
                                                                                        v-if="itemWithSelectedContext['conversation']['is_segmented']"
                                                                                        hide-details="true"
                                                                                        v-model="contextVisualizationForm['units']['token_morphologies']"
                                                                                        label="Morfologías de palabra"></v-checkbox>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card>
                                                                    </v-container>

                                                                    <v-row no-gutters justify="end">
                                                                        <v-col cols="auto">
                                                                            <v-btn class="mr-3" color="white"
                                                                                @click="loadInterventionContextGrid(); context_visualization_dialog = false;"
                                                                                small>
                                                                                Filtrar
                                                                            </v-btn>
                                                                            <v-btn class="mr-3" color="white"
                                                                                @click="resetContextVisualizationSection();"
                                                                                small>
                                                                                Borrar
                                                                            </v-btn>
                                                                            <v-btn class="mr-3" color="white"
                                                                                @click="context_visualization_dialog = false;"
                                                                                small>
                                                                                Cerrar
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-dialog>
                                            <v-col class="pa-1 pt-1" cols="auto">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on"
                                                            @click="generateDetailsDoc()">mdi-file-word</v-icon>
                                                    </template>
                                                    "Descargar ejemplo en word"
                                                </v-tooltip>
                                            </v-col>
                                            <v-col class="pa-1 pt-1" cols="auto">

                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on"
                                                            @click="generateDetailsExcel()">mdi-file-excel</v-icon>
                                                    </template>
                                                    "Descargar ejemplo en excel"
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!-- CONTEXT DATA TABLE -->
                            <v-row no-gutters justify="end">
                                <v-col class="pa-1 pt-2" cols="12">
                                    <v-data-table class="transparent elevation-2" item-key="cod"
                                        v-model="selected_details" :headers="detail_headers" :items="detail_items"
                                        locale="es-ES" :loading="loading_details" loading-text="Cargando datos..."
                                        no-data-text="No hay ningún resultado seleccionado."
                                        :items-per-page="detail_items.length" allowColumnResizing dense
                                        hide-default-footer>

                                        <template v-slot:item="{ item, index, expand, isExpanded }">
                                            <tr :id="'row_' + item['cod']"
                                                :class="item['is_observation'] ? 'observation' : item['highlight'] ? 'context-axis' : ''"
                                                :key="item.cod">
                                                <td v-if="itemWithSelectedContext['conversation']['is_segmented']"
                                                    class="text-center" v-html="item.dialog">
                                                </td>
                                                <td style="font-family: monospace !important;" class="text-center"
                                                    v-html="item.conversation_speaker">
                                                </td>
                                                <td v-if="item.intervention_type" class="text-center"
                                                    v-html="item.intervention_type">
                                                </td>
                                                <td class="text-left">
                                                    <div class="interv-contents" v-html="highlight(item)"></div>
                                                </td>
                                            </tr>
                                        </template>

                                        <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                            items.pageStop }} de {{ items.itemsLength }} </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import api from '@/restApi';
import { saveAs } from 'file-saver';
import { Loading } from '@/components';
import { WidthType, BorderStyle, Document, Paragraph, Packer, TextRun, Table, TableRow, TableCell, HeadingLevel, ShadingType, AlignmentType } from "docx";
import moment from 'moment';
import ExcelJS from 'exceljs';
//    import axios from 'axios';

//    var searchFilters = {
//        general: {id: "general", name: 'General'},
//        speaker: {id: "speaker", name: 'Hablante'},
//        intervention: {id: "intervention", name: 'Intervención'},
//        pause: {id: "pause", name: 'Pausa'},
//        intonation: {id: "intonation", name: 'Entonación'},
//        annotation: {id: "annotation", name: 'Grupo entonativo'},
//        lexical_distance: {id: "lexical_distance", name: 'Distancia léxica'}
//    };

export default {
    name: 'advanced-search',
    components: {
        Document, Paragraph, Packer, TextRun, Table, TableRow, TableCell, HeadingLevel, ShadingType, saveAs, BorderStyle, WidthType, AlignmentType,
        [Loading.name]: Loading
    },
    props: {
    },
    data() {
        return {
            debugTextSearch: false,
            player: null,
            // Tabs management
            filters_dialog: false,
            selected_entity_tab: "tab-options",
            search_words: "",
            search_regex: "",
            search_regex_default: "(?<=\\b)(?<![àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ])$text(?=\\s|$|\\.|\\:|,|-|\\¿|\\?|¡|!|\\/|↑|↓|→|º|[|]|\\(|\\)|<)",
            search_text: undefined,
            context_ratio: 2,
            alternate: true,
            audio_is_loading: true,
            selected_result_item: null,
            currentFilter: "",
            expanded: [],
            conversations: [],
            conversation_types: [],
            age_ranges: [],
            age_ranges_2: [],
            educational_levels: [],
            selected_rows: [],
            selected_details: [],
            search_filters: [
                {
                    id: "options",
                    name: 'Opciones',
                    icon: "mdi-access-point"
                },
                {
                    id: "metadata",
                    name: 'Metadatos',
                    icon: "record_voice_over"
                },
                {
                    id: "prosody",
                    name: 'Prosodia',
                    icon: "g_translate"
                },
                {
                    id: "units",
                    name: 'Unidades',
                    icon: "font_download"
                }
            ],
            visualization_dialog: false,
            visualizationForm: {
                units: {
                    speeches: true,
                    dialogs: true,
                    interventions: true,
                    acts: true,
                    subacts: true,
                    token_morphologies: true
                }
            },
            context_visualization_dialog: false,
            contextVisualizationForm: {
                units: {
                    speeches: true,
                    dialogs: true,
                    interventions: true,
                    acts: true,
                    subacts: true,
                    token_morphologies: true
                }
            },
            filterForm: {
                options: {
                    token_mode: "shape",
                    capital_mode: undefined,
                    accents: undefined,
                    preceded: undefined,
                    filter_position_char: undefined
                },
                metadata: {
                    conversation: undefined,
                    conversation_type: undefined,
                    conv_year_init: undefined,
                    conv_year_end: undefined,
                    speaker_age_range: undefined,
                    speaker_age_range_2: undefined,
                    speaker_genre: undefined,
                    speaker_educational_level: undefined
                },
                units: {
                    subactsSSD: false,
                    subactsSSS: false,
                    subactsSSTop: false,
                    subactsSSX: false,
                    subactsSAT: false,
                    subactsSAI: false,
                    subactsSAX: false,
                    initiative: false,
                    reactive: false,
                    reactive_initiative: false,
                    independent: false
                },
                prosody: {
                    tone_ascending: false,
                    tone_descending: false,
                    tone_suspended: false,
                    tone_circumflex: false
                }
            },
            // TABLE
            result_headers: [
                {
                    text: "",
                    sortable: false,
                    width: 20
                },
                {
                    text: "COD",
                    sortable: false,
                    value: "cod",
                    width: 110
                },
                {
                    text: "Conv",
                    align: "center",
                    value: "conversation_speaker.conversation.name",
                    width: 90
                },
                {
                    text: "Tipo",
                    align: "center",
                    value: "intervention_type",
                    width: 90
                },
                {
                    text: "Habl.",
                    align: "center",
                    value: "speaker",
                    sortable: false,
                    width: 100
                },
                //                    {
                //                        text: "Id",
                //                        align: "start",
                //                        sortable: "false",
                //                        value: "cod"
                //                    },
                {
                    text: "Contenido",
                    align: "center",
                    value: "formatted_contents"
                },
                {
                    text: "",
                    sortable: false,
                    width: 60
                }
            ],
            loading_results: false,
            loading_details: false,
            result_items: [],
            interventionsTotalCount: 0,
            result_conversation_count: 0,
            detail_headers: [],
            detail_headers_default: [
                // {
                //     text: "Cod",
                //     align: "start",
                //     value: "cod",
                //     sortable: false
                // },
                {
                    text: "Dial.",
                    align: "start",
                    value: "dialog",
                    sortable: false,
                    width: 40
                },
                {
                    text: "Habl.",
                    align: "center",
                    value: "speaker",
                    sortable: false,
                    width: 120
                },
                {
                    text: "Tipo",
                    align: "center",
                    value: "intervention_type",
                    sortable: false
                },
                {
                    text: "Contenido",
                    align: "center",
                    value: "formatted_contents",
                    sortable: false
                }
            ],
            detail_items: [],
            options: {},
            // TOKEN MORPHOLOGY OPTIONS
            word_types: [
                "Abreviatura",
                "Adjetivo",
                "Adverbio",
                //                    "Cifra",
                "Conjunción",
                "Determinante",
                "Expresión adjetiva",
                //                    "Fecha",
                //                    "Hora",
                "Interjección",
                "No Categorizada",
                "Pronombre",
                "Palabra cortada",
                //                    "Pausa",
                "Preposición",
                "Sigla",
                //                    "Signo de puntuación",
                "Sustantivo",
                "Verbo"
            ],
            numbers: [
                "Singular",
                "Plural",
                "Plural/Singular"
            ],
            genres: [
                "Femenino",
                "Masculino",
                "Masculino/Femenino",
                "Masculino/Femenino/Neutro",
                "Masculino/Neutro",
                "Neutro"
            ],
            persons: [
                "1ª persona del singular",
                "2ª persona del singular",
                "3ª persona del singular",
                "1ª persona del plural",
                "2ª persona del plural",
                "3ª persona del plural"
            ],
            tenses: [
                "Copretérito",
                "Copretérito en -se",
                "Futuro",
                "Pospretérito",
                "Presente",
                "Presente/Pretérito",
                "Pretérito"
            ],
            moods: [
                "Gerundio",
                "Indicativo",
                "Imperativo",
                "Imperativo/Indicativo",
                "Imperativo/Subjuntivo",
                "Infinitivo",
                "Participio",
                "Subjuntivo"
            ],
            sust_types: [
                "Común",
                "Propio"
            ],
            pronom_types: [
                "Comparativo",
                "Cuantificador",
                "Demostrativo",
                "Distributivo",
                "Exclamativo o interrogativo",
                "Globalizador",
                "Indefinido",
                "Numeral cardinal",
                "Numeral ordinal",
                "Numeral partitivo",
                "Personal",
                "Posesivo",
                "Reflexivo",
                "Relativo"
            ],
            pronom_subtypes: [
                "Acusativo",
                "Acusativo/Predicativo",
                "Dativo",
                "Dativo/Medio",
                "Nominativo",
                "Nominativo/Preposicional",
                "Singular preposicional"
            ],
            det_types: [
                "Artículo determinado",
                "Artículo indeterminado",
                "Comparativo",
                "Cuantificador",
                "Demostrativo",
                "Exclamativo o interrogativo",
                "Distributivo",
                "Globalizador",
                "Indefinido",
                "Numeral cardinal",
                "Numeral ordinal",
                "Numeral partitivo",
                "Posesivo",
                "Reflexivo",
                "Relativo"
            ],
            itemWithSelectedContext: null,
            result_card_cols: 12,
            detail_card_cols: 5,
            result_tokens_count: 0
        };
    },
    created: function () {
        this.search_regex = this.search_regex_default;

        this.loadConversations();
        this.loadConversationTypes();
        this.loadAgeRanges();
        this.loadAgeRanges2();
        this.loadEducationalLevels();
        //            this.doSearch();
    },
    mounted: function () {
        //            this.$validator.localize('es', this.dictionary);
    },
    computed: {
        filtered_result_headers() {
            console.log(this.$env.type)
            // Filter out the "COD" column if the environment is "PRODUCTION"
            if (this.$env.type === 'PRODUCTION') {
                return this.result_headers.filter(header => header.value !== 'cod');
            }

            return this.result_headers;
        }
    },
    watch: {
        selected_entity_tab: function () {
            this.current_search_section = "tab-general";
            //                this.doSearch();
        },
        options: {
            async handler(options) {
                this.doPagination(options);
            },
            deep: true
        },
    },
    methods: {
        doPagination(options) {
            // console.log("Paginating...");

            if (this.loading_results) {
                return;
            }

            this.result_items = [];
            this.detail_items = [];

            this.loading_results = true;

            this.resetContextDetails();
            this.searchInterventions(options);
        },
        speak() {
            // Create a SpeechSynthesisUtterance
            const utterance = new SpeechSynthesisUtterance("Welcome to this tutorial!");

            // Select a voice
            const voices = speechSynthesis.getVoices();

            utterance.voice = voices[0]; // Choose a specific voice

            // Speak the text
            speechSynthesis.speak(utterance);

        },
        resetContextDetails() {
            var self = this;

            self.result_card_cols = 12;
            self.detail_items = [];
            self.itemWithSelectedContext = null;
        },
        async loadContextPanel(selectedItem) {
            var self = this;

            if (self.hasContextPanel(selectedItem)) {
                self.resetContextDetails();

                return;
            }

            self.result_card_cols = 7;

            self.placeContextCard(selectedItem);

            self.itemWithSelectedContext = selectedItem;


            self.loadInterventionContextGrid();
        },
        placeContextCard(selectedItem) {
            if (!selectedItem) {
                return;
            }

            var contextCard = document.getElementById("contextCard");
            var resultsCard = document.getElementById("resultsCard");
            var rowElement = document.getElementById("row_" + selectedItem['cod']);

            if (!contextCard || !resultsCard) {
                return;
            }

            const rect = rowElement.getBoundingClientRect();
            const rect2 = resultsCard.getBoundingClientRect();

            contextCard.style.top = rect.top - rect2.top + 'px';
        },
        hasContextPanel(item) {
            if (!item) {
                return false;
            }

            if (!this.itemWithSelectedContext) {
                return false;
            }

            return (this.itemWithSelectedContext["cod"] === item["cod"]);
        },
        async loadInterventionDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log("Expanded item", item);
            //                console.log("Element", "plyr_inter_" + item["cod"]);
            //                console.log("Expanded", self.expanded)
            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                    console.log(item2["cod"], "-", item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO", isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        isSustTypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Sustantivo"
            );
        },
        isDetTypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Determinante"
            );
        },
        isPronomTypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isPronomSubtypeVisible() {
            return (
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isPersonVisible() {
            return (
                (this.filterForm['options']['word_type'] === "Determinante" && this.filterForm['options']['type'] === "Posesivo") ||
                this.filterForm['options']['word_type'] === "Verbo" ||
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isGenreVisible() {
            return (
                this.filterForm['options']['word_type'] === "Adjetivo" ||
                this.filterForm['options']['word_type'] === "Determinante" ||
                this.filterForm['options']['word_type'] === "Sustantivo" ||
                this.filterForm['options']['word_type'] === "Pronombre"
            );
        },
        isNumberVisible() {
            return (
                this.filterForm['options']['word_type'] === "Adjetivo" ||
                this.filterForm['options']['word_type'] === "Determinante" ||
                this.filterForm['options']['word_type'] === "Sustantivo" ||
                this.filterForm['options']['word_type'] === "Pronombre" ||
                this.filterForm['options']['word_type'] === "Verbo"
            );
        },
        isTenseVisible() {
            return (
                this.filterForm['options']['word_type'] === "Verbo"
            );
        },
        isMoodVisible() {
            return (
                this.filterForm['options']['word_type'] === "Verbo"
            );
        },
        async loadAgeRanges() {
            var queryString;

            queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all
            this.age_ranges = await api.getAllItems("age_range", queryString);
        },
        async loadAgeRanges2() {
            var queryString;

            queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all
            this.age_ranges_2 = await api.getAllItems("age_range_2", queryString);
        },
        async loadEducationalLevels() {
            var queryString;

            queryString = "fields=cod,name,description&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all sections for page
            this.educational_levels = await api.getAllItems("educational_level", queryString);
        },
        async loadConversations() {
            var queryString;

            queryString = "fields=cod,name&sort={\"field\":\"name\",\"dir\":\"asc\"}";

            // Get all sections for page
            this.conversations = await api.getAllItems("conversation", queryString);
        },
        async loadConversationTypes() {
            var queryString;

            queryString = "fields=cod,name&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all sections for page
            this.conversation_types = await api.getAllItems("conversation_type", queryString);
        },
        async doSearch() {
            var self = this;

            if (!this.search_words) {
                return;
            }

            self.resetContextDetails();

            this.search_text = this.search_words;
            //                console.log("Searching by", this.selected_entity_tab);

            this.result_items = [];
            this.detail_items = [];

            this.loading_results = true;
            //                this.loading_details = true;

            this.searchInterventions({ page: 0, itemsPerPage: 10 });

            this.currentFilter = this.getSearchHtmlSummary(this.filterForm);
        },
        async searchInterventions(options) {
            var fields, sort, queryString;
            var segmentationOptions;
            var self = this;


            // Reset selection
            self.selected_rows = [];

            queryString = self.createQueryString();

            queryString += "&is_html=true"

            if (self.debugTextSearch) {
                self.search_regex = "$text(?=\\s|$|\\.|\\:|,|-|\\¿|\\?|¡|!|\\/|↑|↓|→|º|[|]|\\(|\\))";
            } else {
                self.search_regex = self.search_regex_default;
            }

            // VISUALIZATION OPTIONS
            segmentationOptions = "";
            // segmentationOptions = "speeches,dialogs,turns,interventions,acts,subacts";
            if (self.visualizationForm["units"]["speeches"]) {
                segmentationOptions += "speeches,";
            }
            if (self.visualizationForm["units"]["dialogs"]) {
                segmentationOptions += "dialogs,";
            }
            //                if (self.visualizationForm["units"]["turns"]) {
            //                    visualizationOptions += "turns,";
            //                }
            if (self.visualizationForm["units"]["interventions"]) {
                segmentationOptions += "interventions,";
            }
            if (self.visualizationForm["units"]["acts"]) {
                segmentationOptions += "acts,";
            }
            if (self.visualizationForm["units"]["subacts"]) {
                segmentationOptions += "subacts,";
            }
            if (self.visualizationForm["units"]["token_morphologies"]) {
                segmentationOptions += "token_morphologies";
            }

            if (!self.$mout.lang.isEmpty(segmentationOptions)) {
                segmentationOptions = self.$mout.string.rtrim(segmentationOptions, ",");
            }

            // Add search regex to query string
            queryString += "&regex=" + encodeURI(self.search_regex);

            fields = "cod,conversation,conversation_speaker,formatted_contents,plain_contents,intervention_type,is_observation,start,is_direct_speech,search_data, intervention_number,turn_number,intervention_key";
            sort = "{\"field\":\"order\",\"dir\":\"asc\"}";


            if (!self.$mout.lang.isEmpty(fields)) {
                // Add fields to query string
                queryString += "&fields=" + fields;
            }

            if (!self.$mout.lang.isEmpty(sort)) {
                // Add sort to query string
                queryString += "&sort=" + sort;
            }

            if (!self.$mout.lang.isEmpty(segmentationOptions)) {
                // Add segmentation options to query string
                queryString += "&segmentation_options=" + segmentationOptions;
            }

            queryString += "&pageSize=" + options["itemsPerPage"] + "&pageIndex=" + options["page"];

            // Get all interventions that match the search
            const response = await api.searchInterventions(queryString);

            // console.log(response)

            // Get interventions
            this.result_items = response["data"];

            this.interventionsTotalCount = response["count"];

            self.result_tokens_count = response["search_words_ocurrencies"];
            self.result_conversation_count = response["search_result_conversations_count"];

            for (var i in self.result_items) {
                self.result_items[i]["highlight"] = true;
            }

            self.loading_results = false;
        },
        createQueryString() {
            var queryString, toneFilter, subactTypeFilter, interventionTypeFilter;
            var self = this;

            queryString = "search=" + self.search_text;

            // Format options filter
            if (self.filterForm["options"]["token_mode"]) {
                queryString += "&token_mode=" + self.filterForm["options"]["token_mode"];
            }
            if (self.filterForm["options"]["capital_mode"]) {
                queryString += "&capital_mode=" + self.filterForm["options"]["capital_mode"];
            }
            if (self.filterForm["options"]["accents"]) {
                queryString += "&accents=" + self.filterForm["options"]["accents"];
            }
            if (self.filterForm["options"]["filter_position"]) {
                queryString += "&filter_position=" + self.filterForm["options"]["filter_position"];
            }
            if (self.filterForm["options"]["filter_position_char"]) {
                queryString += "&filter_position_char=" + self.filterForm["options"]["filter_position_char"];
            }
            if (self.filterForm["options"]["word_type"]) {
                queryString += "&word_type=" + self.filterForm["options"]["word_type"];
            }
            if (self.filterForm["options"]["type"]) {
                queryString += "&type=" + self.filterForm["options"]["type"];
            }
            if (self.filterForm["options"]["subtype"]) {
                queryString += "&subtype=" + self.filterForm["options"]["subtype"];
            }
            if (self.filterForm["options"]["person"]) {
                queryString += "&person=" + self.filterForm["options"]["person"];
            }
            if (self.filterForm["options"]["genre"]) {
                queryString += "&genre=" + self.filterForm["options"]["genre"];
            }
            if (self.filterForm["options"]["number"]) {
                queryString += "&number=" + self.filterForm["options"]["number"];
            }
            if (self.filterForm["options"]["mood"]) {
                queryString += "&mood=" + self.filterForm["options"]["mood"];
            }
            // Format metadata filter
            if (self.filterForm["metadata"]["conversation"]) {
                queryString += "&conv=" + self.filterForm["metadata"]["conversation"];
            }
            if (self.filterForm["metadata"]["conversation_type"]) {
                queryString += "&conversation_type=" + self.filterForm["metadata"]["conversation_type"];
            }
            if (self.filterForm["metadata"]["speaker_age_range"]) {
                queryString += "&conversation_speaker.age_range.cod=" + self.filterForm["metadata"]["speaker_age_range"]["cod"];
            }
            if (self.filterForm["metadata"]["speaker_age_range_2"]) {
                queryString += "&conversation_speaker.age_range_2.cod=" + self.filterForm["metadata"]["speaker_age_range_2"]["cod"];
            }
            if (self.filterForm["metadata"]["speaker_educational_level"]) {
                queryString += "&conversation_speaker.educational_level.cod=" + self.filterForm["metadata"]["speaker_educational_level"]["cod"];
            }
            if (self.filterForm["metadata"]["speaker_genre"]) {
                queryString += "&conversation_speaker.genre=" + self.filterForm["metadata"]["speaker_genre"];
            }
            if (self.filterForm["metadata"]["conv_year_init"]) {
                queryString += "&conv_year_init=" + self.filterForm["metadata"]["conv_year_init"];
            }
            if (self.filterForm["metadata"]["conv_year_end"]) {
                queryString += "&conv_year_end=" + self.filterForm["metadata"]["conv_year_end"];
            }
            // Format units filter
            toneFilter = "";
            if (self.filterForm["prosody"]["tone_ascending"]) {
                toneFilter += "ascending,";
            }
            if (self.filterForm["prosody"]["tone_descending"]) {
                toneFilter += "descending,";
            }
            if (self.filterForm["prosody"]["tone_suspended"]) {
                toneFilter += "suspended,";
            }
            if (self.filterForm["prosody"]["tone_circumflex"]) {
                toneFilter += "circumflex,";
            }
            if (!self.$mout.lang.isEmpty(toneFilter)) {
                //                    console.log(toneFilter);
                toneFilter = self.$mout.string.rtrim(toneFilter, ",");
                queryString += "&tone=" + toneFilter;
            }

            subactTypeFilter = "";
            if (self.filterForm["units"]["subactsSAX"]) {
                subactTypeFilter += "SAX,";
            }
            if (self.filterForm["units"]["subactsSAT_M"]) {
                subactTypeFilter += "SAT_M,";
            }
            if (self.filterForm["units"]["subactsSAT_I"]) {
                subactTypeFilter += "SAT_I,";
            }
            if (self.filterForm["units"]["subactsSAM_T"]) {
                subactTypeFilter += "SAM_T,";
            }
            if (self.filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI,";
            }
            if (self.filterForm["units"]["subactsSAI_T"]) {
                subactTypeFilter += "SAI_T,";
            }
            if (self.filterForm["units"]["subactsSSX"]) {
                subactTypeFilter += "SSX,";
            }
            if (self.filterForm["units"]["subactsSAM_I"]) {
                subactTypeFilter += "SAM_I,";
            }
            if (self.filterForm["units"]["subactsSAI_M"]) {
                subactTypeFilter += "SAI_M,";
            }
            if (self.filterForm["units"]["subactsSS_SSA"]) {
                subactTypeFilter += "SS_SA,";
            }
            if (self.filterForm["units"]["residue"]) {
                subactTypeFilter += "residue,";
            }
            if (self.filterForm["units"]["subactsSSS"]) {
                subactTypeFilter += "SSS,";
            }
            if (self.filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI,";
            }
            if (self.filterForm["units"]["subactsSAM"]) {
                subactTypeFilter += "SAM,";
            }
            if (self.filterForm["units"]["subactsSS_SA"]) {
                subactTypeFilter += "SS_SA,";
            }
            if (self.filterForm["units"]["subactsSSTop"]) {
                subactTypeFilter += "SSS_Top,";
            }
            if (self.filterForm["units"]["subactsSAT"]) {
                subactTypeFilter += "SAT,";
            }
            if (self.filterForm["units"]["subactsSSD"]) {
                subactTypeFilter += "SSD";
            }
            if (!self.$mout.lang.isEmpty(subactTypeFilter)) {
                //                    console.log(subactTypeFilter)
                subactTypeFilter = self.$mout.string.rtrim(subactTypeFilter, ",");
                queryString += "&subact_type=" + subactTypeFilter;
            }

            interventionTypeFilter = "";
            if (self.filterForm["units"]["initiative"]) {
                interventionTypeFilter += "i,";
            }
            if (self.filterForm["units"]["reactive"]) {
                interventionTypeFilter += "r,";
            }
            if (self.filterForm["units"]["reactive_initiative"]) {
                interventionTypeFilter += "ri,";
            }
            if (self.filterForm["units"]["independent"]) {
                interventionTypeFilter += "ind";
            }
            if (!self.$mout.lang.isEmpty(interventionTypeFilter)) {
                //                    console.log(interventionTypeFilter)
                interventionTypeFilter = self.$mout.string.rtrim(interventionTypeFilter, ",");
                queryString += "&intervention_type=" + interventionTypeFilter;
            }


            return queryString;
        },
        highlight(item) {
            var contents;
            var searchText;
            var toneChar;
            var result;
            var self = this;

            contents = item["formatted_contents"];

            searchText = self.search_text;

            // console.log(item)

            // Escape regex special characters
            const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            // Build flexible regex: allow **one arbitrary character inside the word**
            searchText = searchText
                .split('')
                .map((c, i) => i === 0 ? c : `.{0,1}${escapeRegex(c)}`) // allow 0 or 1 extra char before each subsequent letter
                .join('');

            searchText = searchText + "+";

            if (self.$mout.lang.isEmpty(searchText) || !item["highlight"]) {
                return contents;
            }

            // Format units filter
            if (self.filterForm["prosody"]["tone_ascending"]) {
                toneChar = "↑";
            }
            if (self.filterForm["prosody"]["tone_descending"]) {
                toneChar = "↓";
            }
            if (self.filterForm["prosody"]["tone_suspended"]) {
                toneChar = "→";
            }
            if (self.filterForm["prosody"]["tone_circumflex"]) {
                toneChar = "^";
            }


            if (!this.$mout.lang.isEmpty(toneChar)) {
                // result = contents.replace(new RegExp(searchFilter, "gm"), match => {
                //     return '<span class="highlightText">' + match + '</span>';
                // });
                result = this.highlightTextSearchWordWithChar(contents, searchText, toneChar, item["search_data"]);

                if (this.$mout.string.contains('class="tooltip')) {
                    result = this.highlightTextWithTooltipsSearchWordWithChar(result, searchText, toneChar);
                }
            } else {
                result = this.highlightTextSearchWordWithChar(contents, searchText, toneChar, item["search_data"]);
                // result = contents.replace(new RegExp(searchFilter, "gm"), match => {
                //     return '<span class="highlightText">' + match + '</span>';
                // });
            }

            return result;
        },
        highlightTextSearchWordWithChar(html, searchWord, toneChar, searchData) {
            var regexString;
            var searchFilter;
            var self = this;

            regexString = self.search_regex_default;

            const wordBoundaryCharPreffix = regexString.substring(0, regexString.indexOf(")$text", 20) + 1);
            // const wordBoundaryCharSuffix = regexString.substring(regexString.lastIndexOf("(?"), regexString.length);

            //                console.log("Prefix:", wordBoundaryCharPreffix)
            //                console.log("Suffix:", wordBoundaryCharSuffix)

            // If there is search data
            // if (!this.$mout.lang.isEmpty(searchData) && !this.$mout.lang.isEmpty(searchData["tokens_parsed"])) {
            //     searchFilter = "";
            //     for (var i in searchData["tokens_parsed"]) {
            //         searchWord = self.escapeRegExp(searchData["tokens_parsed"][i]);

            //         if (!this.$mout.lang.isEmpty(toneChar)) {
            //             searchFilter += wordBoundaryCharPreffix + "" + searchWord + toneChar + "|";
            //             searchFilter += wordBoundaryCharPreffix + "" + searchWord + "." + toneChar + "|";
            //             searchFilter += wordBoundaryCharPreffix + "" + searchWord + ".." + toneChar + "|";
            //             searchFilter += wordBoundaryCharPreffix + "" + searchWord + "..." + toneChar + "|";
            //         } else {
            //             searchFilter += wordBoundaryCharPreffix + searchWord + wordBoundaryCharSuffix + "|";
            //         }
            //     }

            //     searchFilter = this.$mout.string.rtrim(searchFilter, "|");
            //     //                    searchFilter = searchFilter.substring(0, searchFilter.length - 1);
            // } else {
            if (!this.$mout.lang.isEmpty(toneChar)) {
                searchFilter = wordBoundaryCharPreffix + "" + searchWord + toneChar + "|";
                searchFilter += wordBoundaryCharPreffix + "" + searchWord + "." + toneChar + "|";
                searchFilter += wordBoundaryCharPreffix + "" + searchWord + ".." + toneChar + "|";
                searchFilter += wordBoundaryCharPreffix + "" + searchWord + "..." + toneChar;
            } else {
                var regExpression = regexString.replace("$text", searchWord);

                searchFilter = regExpression;
            }
            // }

            //                if (self.filterForm["options"]["filter_position"] === "preceded" ||
            //                        self.filterForm["options"]["filter_position"] === "both") {
            //                    switch (self.filterForm["options"]["filter_position_char"]) {
            //                        case "exclamation_mark":
            //                            filterPositionCondition["token.prefix"] = "¡";
            //                            break;
            //                        case "question_marks":
            //                            filterPositionCondition["token.prefix"] = "¿";
            //                            break;
            //                        case "slash":
            //                            filterPositionCondition["token.prefix"] = "/";
            //                            break;
            //                    }
            //                }
            //                if (self.filterForm["options"]["filter_position"] === "followed" ||
            //                        self.filterForm["options"]["filter_position"] === "both") {
            //                    switch (self.filterForm["options"]["filter_position_char"]) {
            //                        case "exclamation_mark":
            //                            filterPositionCondition["token.suffix"] = "!";
            //                            break;
            //                        case "question_marks":
            //                            filterPositionCondition["token.suffix"] = "?";
            //                            break;
            //                        case "slash":
            //                            filterPositionCondition["token.suffix"] = "/";
            //                            break;
            //                    }
            //                }

            ////                console.log("-------------------------");
            // console.log(item["cod"], searchFilter);
            // console.log(item["cod"], this.search_text);
            // console.log(contents);


            //                return contents.replace(new RegExp(this.search_text, "gi"), match => {
            if (this.$mout.lang.isEmpty(searchFilter)) {
                return html;
            }

            const result = html.replace(new RegExp(searchFilter, "gm"), match => {
                return '<span class="highlightText">' + match + '</span>';
            });

            return result;
        },
        highlightTextWithTooltipsSearchWordWithChar(html, searchWord, arrowChar) {
            // Escape regex special characters
            const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            // Regex to match tooltip + word + arrow
            const regex = new RegExp(
                `(\\<div\\s+class="tooltip\\b[^>]*">)` + // opening tooltip
                `((?:(?!<div\\s+class="tooltip\\b).)*?)` + // content inside tooltip
                `(${searchWord})` +                        // word with optional char inside
                `((?:(?!<div\\s+class="tooltip\\b).)*?</div>)` + // rest of tooltip
                `(${escapeRegex(arrowChar)})`,               // arrow immediately after
                's' // dot matches newlines
            );

            // Replace first occurrence
            const result = html.replace(regex, (match, openDiv, beforeWord, word, afterWord, arrow) => {
                const highlightedWord = `<span class="highlightText">${word}</span>`;
                const highlightedArrow = `<span class="highlightText">${arrow}</span>`;
                return openDiv + beforeWord + highlightedWord + afterWord + highlightedArrow;
            });

            return result;
        },
        escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },
        async checkSelected(selectedItem) {
            if (this.selected_rows.length <= 0) {
                return;
            }

            //                this.updateDetailedView(selectedItem);
        },
        async loadInterventionContextGrid() {
            this.detail_items = [];

            this.detail_items = await this.loadInterventionContext(true);
        },
        async loadInterventionContext(isForHtml) {
            var queryString;
            var fields;
            var visualizationOptions;
            var detailRows;
            var debug;
            var self = this;

            this.loading_details = true;

            detailRows = [];
            //                isSegmented=self.selected_result_item["is_segmented"];

            self.detail_headers = self.$mout.lang.clone(self.detail_headers_default);

            // VISUALIZATION OPTIONS
            visualizationOptions = "";
            if (self.contextVisualizationForm["units"]["speeches"]) {
                visualizationOptions += "speeches,";
            }
            if (self.contextVisualizationForm["units"]["dialogs"]) {
                visualizationOptions += "dialogs,";
                //                    self.detail_headers = self.detail_headers_default;
            }

            if (!self.itemWithSelectedContext["conversation"]["is_segmented"]) {
                self.detail_headers.splice(0, 1);
            }
            if (self.contextVisualizationForm["units"]["turns"]) {
                visualizationOptions += "turns,";
            }
            if (self.contextVisualizationForm["units"]["interventions"]) {
                visualizationOptions += "interventions,";
            }
            if (self.contextVisualizationForm["units"]["acts"]) {
                visualizationOptions += "acts,";
            }
            if (self.contextVisualizationForm["units"]["subacts"]) {
                visualizationOptions += "subacts";
            }

            if (!self.$mout.lang.isEmpty(visualizationOptions)) {
                visualizationOptions = self.$mout.string.rtrim(visualizationOptions, ",");
            }

            // Create the query
            fields = "conversation_speaker,intervention_type,formatted_contents,dialog,is_direct_speech,is_observation,intervention_number,turn_number,start";

            //                populate = "conversation_speaker.conversation.cod,conversation_speaker.conversation.name,dialog";

            queryString = "sort={\"field\":\"order\",\"dir\":\"asc\"}&is_html=" + isForHtml + "&fields=" + fields;

            //                queryString = "populate=" + populate + "&fields=" + fields + "&sort={\"field\":\"order\",\"dir\":\"asc\"}&units=" + visualizationOptions + "&html=" + isForHtml;

            debug = "";
            //                self.filterForm["metadata"]["conversation"] = "046";
            //                visualizationOptions = "turns,interventions";
            //                visualizationOptions = "turns,interventions,acts,subacts";
            //                if (self.filterForm["metadata"]["conversation"] === "046") {
            //                    debug = "&debug=true";
            //                }

            if (!self.$mout.lang.isEmpty(visualizationOptions)) {
                queryString += "&segmentation_options=" + visualizationOptions + debug;
            }

            // Get all sections for page
            detailRows = await api.getInterventionContext(self.itemWithSelectedContext["_id"], self.context_ratio, queryString);

            for (var i in detailRows) {
                if (detailRows[i]["cod"] === self.itemWithSelectedContext["cod"]) {
                    detailRows[i]["highlight"] = true;
                }

                //                    console.log(detailRows[i])
                //                    detailRows[i]["speaker"] = detailRows[i]['conversation_speaker'];
                detailRows[i]["intervention_type"] = self.$mout.lang.isEmpty(detailRows[i]["intervention_type"]) ? "" : detailRows[i]['intervention_type'];

                ////                    this.detail_items[i]["formatted_contents"] = this.detail_items[i]["formatted_contents"].replace(/&lt;.*?&gt;/g, '');
                ////                    this.detail_items[i]["conversation_speaker"]["cod"] = this.detail_items[i]["conversation_speaker"]["cod"] + ":";

                //                    detailRows[i]["start"] = detailRows[i]["start"];

                self.loading_details = false;
            }

            return detailRows;
        },
        async resetFilters() {
            var self = this;

            self.resetFilterSection("options");
            self.resetFilterSection("metadata");
            self.resetFilterSection("prosody");
            self.resetFilterSection("units");
        },
        async resetFilterSection(section) {
            switch (section) {
                case "options":
                    this.filterForm["options"] = {
                        token_mode: "shape",
                        capital_mode: null,
                        accents: null,
                        filter_position: null,
                        filter_position_char: null,
                        word_type: null,
                        type: null,
                        subtype: null,
                        person: null,
                        genre: null,
                        number: null,
                        mood: null,
                        tense: null
                    };
                    break;
                case "metadata":
                    this.filterForm["metadata"] = {
                        conversation: null,
                        conv_year_init: null,
                        conv_year_end: null,
                        speaker_age_range: null,
                        speaker_age_range_2: null,
                        speaker_genre: null,
                        speaker_educational_level: null
                    };
                    break;
                case "units":
                    this.filterForm["units"] = {
                        speeches: false,
                        dialogs: false,
                        turns: false,
                        interventions: false,
                        acts: false,
                        subactsSSD: false,
                        subactsSSS: false,
                        subactsSSTop: false,
                        subactsSSX: false,
                        subactsSAT: false,
                        subactsSAI: false,
                        subactsSAX: false
                    };
                    break;
                case "prosody":
                    this.filterForm["prosody"] = {
                        tone_ascending: false,
                        tone_descending: false,
                        tone_suspended: false,
                        tone_circumflex: false
                    };
                    break;
            }
        },
        async resetWordTypeSection() {
            this.filterForm["options"]["subtype"] = null;
            this.filterForm["options"]["type"] = null;
            this.filterForm["options"]["person"] = null;
            this.filterForm["options"]["genre"] = null;
            this.filterForm["options"]["number"] = null;
            this.filterForm["options"]["mood"] = null;
            this.filterForm["options"]["tense"] = null;
            //                console.log(this.filterForm["options"])
        },
        async resetVisualizationSection() {
            alert
            this.visualizationForm["units"] = {
                speeches: false,
                dialogs: false,
                interventions: false,
                acts: false,
                subacts: false,
                token_morphologies: false
            };
        },
        async resetContextVisualizationSection() {
            this.contextVisualizationForm["units"] = {
                speeches: false,
                dialogs: false,
                interventions: false,
                acts: false,
                subacts: false,
                token_morphologies: false
            };
        },
        generateResultDoc(resultRows) {
            var titleText, explanationText, summaryText, currentDate;
            var docObject;
            var tableRows;
            var tableCells;
            var columnWidths;
            var lines;
            var self = this;

            if (resultRows.lenght <= 0) {
                return;
            }

            currentDate = moment().locale("es").format("D MMMM YYYY");

            titleText = "Resultados de la búsqueda";

            docObject = {
                sections: [{
                    properties: {},
                    children: [
                    ]
                }]
            };

            lines = [
                new TextRun({
                    text: titleText,
                    bold: true,
                    color: "da8d2b",
                    size: 40,
                    heading: HeadingLevel.TITLE
                })
            ];

            explanationText = "Listado de " + self["result_items"].length +
                " resultados encontrados en " + self.result_conversation_count +
                " conversaciones para el texto de búsqueda: '" + self.search_text + "'";
            //                footerText = "* Cita: Pons Bordería, Salvador (dir.) - Corpus Val.Es.Co 3.0. <https://www.valesco.es> [" + currentDate + "]";
            summaryText = this.getSearchSummary(this.filterForm);

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                    after: 200
                },
                children: lines
            }));

            lines = [
                new TextRun({
                    text: explanationText
                })
            ];

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                    after: 200
                },
                children: lines
            }));

            // Print each summary text line delimited by \n
            summaryText.split("\n").forEach(function (line) {
                self.addNewLine(line.replace("\n", ""), docObject)
            });

            tableRows = [];
            columnWidths = [1800, 800, 1200, 5000];

            var padding = 200;

            tableCells = [
                new TableCell({
                    shading: {
                        fill: "000000",
                        type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                        color: "auto"
                    },
                    margins: {
                        top: padding,
                        bottom: padding,
                        left: padding,
                        right: padding
                    },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CONVERSACIÓN",
                                    font: "Arial",
                                    size: 18,
                                    color: "da8d2b"
                                })]
                        })
                    ]
                }),
                new TableCell({
                    shading: {
                        fill: "000000",
                        type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                        color: "auto",
                    },
                    margins: {
                        top: padding,
                        bottom: padding,
                        left: padding,
                        right: padding
                    },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "TIPO",
                                    font: "Arial",
                                    size: 18,
                                    color: "da8d2b"
                                })]
                        })
                    ]
                }),
                new TableCell({
                    shading: {
                        fill: "000000",
                        type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                        color: "auto",
                    },
                    margins: {
                        top: padding,
                        bottom: padding,
                        left: padding,
                        right: padding
                    },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "HABLANTE",
                                    font: "Arial",
                                    size: 18,
                                    color: "da8d2b"
                                })]
                        })
                    ]
                }),
                new TableCell({
                    shading: {
                        fill: "000000",
                        type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                        color: "auto",
                    },
                    margins: {
                        top: 200,
                        bottom: 200,
                        left: 200,
                        right: 200
                    },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CONTENIDO",
                                    font: "Arial",
                                    size: 18,
                                    color: "da8d2b"
                                })]
                        })
                    ]
                })
            ];

            tableRows.push(new TableRow({
                children: tableCells
            }));

            this.$mout.array.forEach(resultRows, function (item, index, arr) {
                var turnNumber, interventionNumber, interventionKey;
                //                    var startIndex;


                //                    console.log(index, ' : ', item);

                //                    var startIndex = item['conversation_speaker'].indexOf("speaker_key") + 2;
                //                    interventionKey = item['conversation_speaker'].substring(startIndex, item['conversation_speaker'].indexOf("span", startIndex) - 2);
                interventionKey = item['intervention_key'];
                turnNumber = item['turn_number'];
                interventionNumber = item['intervention_number'];

                padding = 100;

                tableCells = [
                    new TableCell({
                        margins: {
                            top: padding,
                            bottom: padding,
                            left: padding,
                            right: padding
                        },
                        children: [
                            new Paragraph({
                                text: item["conversation"]["name"],
                                font: "Arial",
                                size: 22,
                                alignment: AlignmentType.CENTER,
                            })
                        ]
                    }),
                    new TableCell({
                        margins: {
                            top: padding,
                            bottom: padding,
                            left: padding,
                            right: padding
                        },
                        children: [
                            new Paragraph({
                                text: item["intervention_type"],
                                font: "Arial",
                                size: 22,
                                alignment: AlignmentType.CENTER,
                            })
                        ]
                    }),
                    new TableCell({
                        margins: {
                            top: padding,
                            bottom: padding,
                            left: padding,
                            right: padding
                        },
                        children: [
                            new Paragraph({
                                text: turnNumber + interventionKey + interventionNumber,
                                font: "Arial",
                                size: 22,
                                alignment: AlignmentType.CENTER,
                            })
                        ]
                    }),
                    new TableCell({
                        margins: {
                            top: padding,
                            bottom: padding,
                            left: padding,
                            right: padding
                        },
                        children: [
                            new Paragraph({
                                text: item["plain_contents"],
                                font: "Arial",
                                size: 22
                            })
                        ]
                    })
                ];

                tableRows.push(new TableRow({
                    children: tableCells
                }));
            });

            docObject["sections"][0]["children"].push(new Table(
                {
                    alignment: AlignmentType.CENTER,
                    columnWidths: columnWidths,
                    rows: tableRows
                }
            ));

            lines = [
                new TextRun(
                    "Pons Bordería, Salvador (dir.): "
                ),
                new TextRun({
                    text: "Corpus Val.Es.Co 3.0. ",
                    italics: true
                }),
                new TextRun({
                    text: "<https://www.valesco.es> [" + currentDate + "]"
                })
            ];

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.RIGHT,
                spacing: {
                    before: 100
                },
                children: lines
            }));

            const doc = new Document(docObject);

            Packer.toBlob(doc).then((blob) => {
                //                    console.log(blob);
                saveAs(blob, "example.docx");
                //                    console.log("Document created successfully");
            });
        },
        addNewLine(text, docObject) {
            var lines;

            lines = [
                new TextRun({
                    text: text,
                })
            ];

            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                    after: 200
                },
                children: lines
            }));
        },
        // DOWNLOAD DOCUMENTS METHODS
        async generateDetailsDoc() {
            var docObject;
            var currentDate;
            var detailRows;
            var self = this;

            detailRows = await self.loadInterventionContext(false);

            if (detailRows.lenght <= 0) {
                return;
            }

            currentDate = moment().locale("es").format("D MMMM YYYY");

            docObject = {
                sections: [{
                    properties: {},
                    children: [
                    ]
                }]
            };

            var lines;

            lines = [];

            this.$mout.array.forEach(detailRows, function (item, index, arr) {
                var key;
                //                    var startIndex;

                //                    console.log(index, ' : ', item);

                //                    startIndex = item['conversation_speaker'].indexOf("speaker_key") + 13;

                //                    key = item['conversation_speaker'].substring(startIndex, item['conversation_speaker'].indexOf("span", startIndex) - 2);
                key = item['conversation_speaker']["key"];

                lines = [new TextRun({
                    text: key + ": " + item["formatted_contents"],
                    font: "Arial",
                    size: 22
                })];

                docObject["sections"][0]["children"].push(new Paragraph({
                    alignment: AlignmentType.LEFT,
                    spacing: {
                        after: 50
                    },
                    children: lines
                }));
            });

            lines = [
                new TextRun(
                    "Pons Bordería, Salvador (dir.): "
                ),
                new TextRun({
                    text: "Corpus Val.Es.Co 3.0. ",
                    italics: true
                }),
                new TextRun({
                    text: "<https://www.valesco.es> [" + currentDate + "]"
                })
            ];
            docObject["sections"][0]["children"].push(new Paragraph({
                alignment: AlignmentType.RIGHT,
                spacing: {
                    before: 200
                },
                children: lines
            }));

            const doc = new Document(docObject);

            Packer.toBlob(doc).then((blob) => {
                //                    console.log(blob);
                saveAs(blob, "example.docx");
                //                    console.log("Document created successfully");
            });
        },
        async generateResultExcel(selectedRows) {
            var titleText, explanationText, summaryText, footerText, startCol, currentDate;
            var workbook;
            var worksheet;
            var rows;
            var border;
            var headerFillStyle, titleFontStyle, headerFontStyle, footerFontStyle;
            var headers;
            var startRow, col, rowNum, len;
            var self = this;

            if (selectedRows.lenght <= 0) {
                return;
            }

            currentDate = moment().locale("es").format("D MMMM YYYY");

            titleText = "Resultados de la búsqueda";
            explanationText = "Listado de " + self.result_items.length +
                " resultados encontrados en " + self.result_conversation_count +
                " conversaciones para el texto de búsqueda: '" + self.search_text + "'";
            footerText = "* Cita: Pons Bordería, Salvador (dir.) - Corpus Val.Es.Co 3.0. <https://www.valesco.es> [" + currentDate + "]";
            summaryText = this.getSearchSummary(this.filterForm);

            workbook = new ExcelJS.Workbook();

            workbook.created = new Date();
            workbook.modified = new Date();

            workbook.views = [
                {
                    x: 0, y: 0, width: 10000, height: 20000,
                    firstSheet: 0, activeTab: 1, visibility: 'visible'
                }
            ];

            worksheet = workbook.addWorksheet('Resultados', {
                headerFooter: { firstHeader: "Resultados de la búsqueda", firstFooter: "Corpus Valesco 3.0" }
            });

            border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            headerFillStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            titleFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                bold: true,
                family: 2,
                size: 14
            };
            headerFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                family: 2,
                size: 11
            };
            footerFontStyle = {
                name: 'Arial',
                family: 2,
                size: 11,
                italic: true
            };

            worksheet.mergeCells('B2:E2');
            worksheet.getRow('2').height = 30;
            worksheet.getCell('C2').value = titleText;
            worksheet.getCell('C2').font = titleFontStyle;
            worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.mergeCells('B3:E3');
            //                worksheet.getRow('3').height = 30;
            worksheet.getCell('C3').value = explanationText;
            //                worksheet.getCell('C3').font = titleFontStyle;
            worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };

            var summaryLineHeight;

            summaryLineHeight = 30;
            if ((summaryText.split("\n").length - 1) >= 0) {
                summaryLineHeight += (summaryText.split("\n").length - 1) * 17;
            }

            // console.log("summary", summaryText)
            // console.log("count", summaryText.split("\n").length-1)
            // console.log("height", summaryLineHeight)

            worksheet.mergeCells('B4:E4');
            worksheet.getCell('C4').value = summaryText;
            worksheet.getRow('4').height = summaryLineHeight;
            worksheet.getCell('C4').alignment = { vertical: 'top', horizontal: 'left', wrapText: true };

            headers = [
                { header: 'CONVERSACIÓN', key: 'conversation', width: 20, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'TIPO', key: 'intervention_type', width: 20, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'HABLANTE', key: 'speaker', width: 15, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'CONTENIDO', key: 'contents', width: 100, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } }
            ];

            startCol = "B";
            startRow = 6;

            col = startCol.toUpperCase();
            rowNum = startRow;

            len = headers.length;
            for (let i = 0; i < len; i++) {
                let nameCol;
                let cell;

                cell = worksheet.getCell(col + rowNum);
                cell.value = headers[i].header;
                nameCol = worksheet.getColumn(col);

                if (headers[i].format) {
                    nameCol.numFmt = headers[i].format;
                }

                nameCol.width = headers[i].width;
                cell.height = 20;
                cell.border = border;
                cell.font = headerFontStyle;
                cell.fill = headerFillStyle;
                cell.alignment = { vertical: 'middle', horizontal: 'center' };

                col = self.nextColumn(col);
            }

            // Add an array of rows
            rows = [];

            this.$mout.array.forEach(selectedRows, function (item, index, arr) {
                var turnNumber, interventionNumber, interventionKey;
                //                    var startIndex;
                var excelLine;
                //                    console.log(index, ' : ', item);


                //                    startIndex = item['speaker'].indexOf("speaker_key") + 13;
                //                    interventionKey = item['speaker'].substring(startIndex, item['speaker'].indexOf("span", startIndex) - 2);
                interventionKey = item["intervention_key"];
                turnNumber = item['turn_number'];
                interventionNumber = item['intervention_number'];


                excelLine = {
                    'conversation': item["conversation"]["name"],
                    'intervention_type': item["intervention_type"],
                    'speaker': turnNumber + interventionKey + interventionNumber,
                    'contents': item["plain_contents"]
                };
                rows.push(excelLine);
            });

            // Set header row height
            const row = worksheet.lastRow;
            row.height = 35;

            for (let r of rows) {
                let cell;
                let i;

                rowNum++;
                col = startCol;
                //                    console.log("Row", r);
                //                    worksheet.getRow(rowNum).height = 30;

                i = 0;
                for (let key in r) {
                    cell = worksheet.getCell(col + rowNum);

                    cell.value = r[key];
                    cell.border = border;
                    cell.alignment = headers[i].alignment;

                    col = self.nextColumn(col);
                    i++;
                    //                        console.log("Column", r[key]);
                }
            }

            rowNum += 2;
            col = "E";

            //                console.log(startCol + rowNum + ":" + col + rowNum)

            worksheet.mergeCells(startCol + rowNum + ":" + col + rowNum);
            worksheet.getRow(rowNum).height = 20;
            worksheet.getCell(startCol + ":" + rowNum).value = footerText;
            worksheet.getCell(startCol + ":" + rowNum).font = footerFontStyle;
            worksheet.getCell(startCol + ":" + rowNum).alignment = { vertical: 'middle', horizontal: 'left' };

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                self.downloadBlob(blob, 'ejemplo.xlsx');
            });
        },
        async generateDetailsExcel() {
            var titleText, footerText, startCol, currentDate;
            var detailRows;
            var conversation;
            var workbook;
            var worksheet;
            var rows;
            var border;
            var headerFillStyle, titleFontStyle, headerFontStyle, footerFontStyle;
            var headers;
            var startRow, col, rowNum, len;
            var self = this;

            detailRows = await self.loadInterventionContext(false);

            if (detailRows.lenght <= 0) {
                return;
            }

            conversation = await self.loadConversation(self.itemWithSelectedContext["name"]);

            currentDate = moment().locale("es").format("D MMMM YYYY");

            titleText = 'Extracto de la conversación ' + conversation["name"];
            footerText = "* Cita: Pons Bordería, Salvador (dir.) - Corpus Val.Es.Co 3.0. https://www.valesco.es> [" + currentDate + "]";

            workbook = new ExcelJS.Workbook();

            workbook.created = new Date();
            workbook.modified = new Date();

            workbook.views = [
                {
                    x: 0, y: 0, width: 10000, height: 20000,
                    firstSheet: 0, activeTab: 1, visibility: 'visible'
                }
            ];

            worksheet = workbook.addWorksheet('Ejemplo', {
                headerFooter: { firstHeader: "Extracto de la conversación", firstFooter: "Corpus Valesco 3.0" }
            });

            border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            headerFillStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            titleFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                bold: true,
                family: 2,
                size: 14
            };
            headerFontStyle = {
                name: 'Arial',
                color: { argb: 'da8d2b' },
                family: 2,
                size: 11
            };
            footerFontStyle = {
                name: 'Arial',
                family: 2,
                size: 11,
                italic: true
            };

            worksheet.mergeCells('C2:E2');
            worksheet.getRow('2').height = 30;
            worksheet.getCell('C2').value = titleText;
            worksheet.getCell('C2').font = titleFontStyle;
            worksheet.getCell('C2').alignment = { vertical: 'middle', horizontal: 'center' };

            headers = [
                //                    {header: 'CONVERSACIÓN', key: 'conversation', width: 20, alignment: {vertical: 'middle', horizontal: 'center'}},
                { header: 'INTERVENCIÓN', key: 'intervention_type', width: 20, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'HABLANTE', key: 'speaker', width: 15, alignment: { vertical: 'middle', horizontal: 'center' } },
                { header: 'CONTENIDO', key: 'contents', width: 100, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } },
                { header: 'INICIO(ms)', key: 'start', width: 15, alignment: { vertical: 'middle', horizontal: 'center' } }
            ];

            startCol = "B";
            startRow = 4;

            col = startCol.toUpperCase();
            rowNum = startRow;

            len = headers.length;
            for (let i = 0; i < len; i++) {
                let nameCol;
                let cell;

                cell = worksheet.getCell(col + rowNum);
                cell.value = headers[i].header;
                nameCol = worksheet.getColumn(col);

                if (headers[i].format) {
                    nameCol.numFmt = headers[i].format;
                }

                nameCol.width = headers[i].width;
                cell.height = 20;
                cell.border = border;
                cell.font = headerFontStyle;
                cell.fill = headerFillStyle;
                cell.alignment = { vertical: 'middle', horizontal: 'center' };

                col = self.nextColumn(col);
            }

            // Add an array of rows
            rows = [];

            this.$mout.array.forEach(detailRows, function (item, index, arr) {
                var turnNumber, interventionNumber, interventionKey;
                //                    var startIndex;
                var excelLine;
                //                    console.log(index, ' : ', item);


                //                    startIndex = item['conversation_speaker'].indexOf("speaker_key") + 13;
                //                    interventionKey = item['conversation_speaker'].substring(startIndex, item['conversation_speaker'].indexOf("span", startIndex) - 2);
                interventionKey = item['conversation_speaker']["key"];
                turnNumber = item['turn_number'];
                interventionNumber = item['intervention_number'];
                excelLine = {
                    //                        'conversation': item["conversation"],
                    'intervention_type': item["intervention_type"],
                    'speaker': turnNumber + interventionKey + interventionNumber,
                    'contents': item["formatted_contents"],
                    'start': item["start"]
                };
                rows.push(excelLine);
            });

            // Set header row height
            const row = worksheet.lastRow;
            row.height = 35;

            for (let r of rows) {
                let cell;
                let i;

                rowNum++;
                col = startCol;
                //                    console.log("Row", r);
                //                    worksheet.getRow(rowNum).height = 30;

                i = 0;
                for (let key in r) {
                    cell = worksheet.getCell(col + rowNum);

                    cell.value = r[key];
                    cell.border = border;
                    cell.alignment = headers[i].alignment;

                    col = self.nextColumn(col);
                    i++;
                    //                        console.log("Column", r[key]);
                }
            }

            rowNum += 2;
            col = "D";

            //                console.log(startCol + rowNum + ":" + col + rowNum)

            worksheet.mergeCells(startCol + rowNum + ":" + col + rowNum);
            worksheet.getRow(rowNum).height = 20;
            worksheet.getCell(startCol + ":" + rowNum).value = footerText;
            worksheet.getCell(startCol + ":" + rowNum).font = footerFontStyle;
            worksheet.getCell(startCol + ":" + rowNum).alignment = { vertical: 'middle', horizontal: 'left' };

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                self.downloadBlob(blob, 'ejemplo.xlsx');
            });
        },
        getSearchSummary(filterForm) {
            var search;

            search = "Filtros de búsqueda:";

            // Format options filter
            if (filterForm["options"]["token_mode"]) {
                search += "\n\t+ Buscando por " + (filterForm["options"]["token_mode"] === "shape" ? "forma" : "lema");
                search += filterForm["options"]["capital_mode"] ? " teniendo en cuenta mayúsculas" : "";
                search += (filterForm["options"]["capital_mode"] && filterForm["options"]["accents"]) ? " y" : "";
                search += (filterForm["options"]["accents"]) ? " teniendo en cuenta acentos" : "";
            }

            if (filterForm["options"]["filter_position"]) {
                search += "\n\t+ Aparece ";
                switch (filterForm["options"]["filter_position"]) {
                    case "preceded":
                        search += "precedido";
                        break;
                    case "followed":
                        search += "seguido";
                        break;
                    case "both":
                        search += "precedido y seguido";
                        break;
                }

                search += " por "

                if (filterForm["options"]["filter_position_char"]) {
                    switch (filterForm["options"]["filter_position_char"]) {
                        case "exclamation_mark":
                            search += "¡!";
                            break;
                        case "question_marks":
                            search += "¿?";
                            break;
                        case "slash":
                            search += "/";
                            break;
                    }
                }
            }


            if (filterForm["options"]["word_type"]) {
                search += "\n\t+ Clase de palabra: " + filterForm["options"]["word_type"] + ".";
            }

            if (filterForm["options"]["type"]) {
                search += "\n\t+ De tipo: " + filterForm["options"]["type"] + ".";
            }

            if (filterForm["options"]["subtype"]) {
                search += "\n\t+ De subtipo: " + filterForm["options"]["subtype"] + ".";
            }

            if (filterForm["options"]["person"]) {
                search += "\n\t+ Persona: " + filterForm["options"]["person"] + ".";
            }

            if (filterForm["options"]["genre"]) {
                search += "\n\t+ Con género: " + filterForm["options"]["genre"] + ".";
            }

            if (filterForm["options"]["number"]) {
                search += "\n\t+ Con número: " + filterForm["options"]["number"] + ".";
            }

            if (filterForm["options"]["mood"]) {
                search += "\n\t+ De modo: " + filterForm["options"]["mood"] + ".";
            }

            // Format metadata filter
            if (filterForm["metadata"]["conversation"]) {
                // console.log(this.conversations)
                const conversation = this.conversations.filter((conversation) => {
                    // console.log(conversation["cod"])
                    return conversation["cod"] === filterForm["metadata"]["conversation"];
                });

                if (conversation && conversation[0]) {
                    search += "\n\t+ Buscando en la conversación " + conversation[0]["name"] + ".";
                } else {
                    search += "\n\t+ Buscando en la conversación " + filterForm["metadata"]["conversation"] + ".";
                }
            }

            if (filterForm["metadata"]["conv_year_init"] && filterForm["metadata"]["conv_year_end"]) {
                search += "\n\t+ Conversaciones grabadas entre el " + filterForm["conv_year_init"];
                search += " y el " + filterForm["conv_year_end"] + ".";
            }

            if (filterForm["metadata"]["conversation_type"]) {
                search += "\n\t+ Buscando en conversaciones de tipo ";
                switch (filterForm["metadata"]["conversation_type"]) {
                    case "cod_prototypical":
                        search += "prototípica.";
                        break;
                    case "cod_periferical":
                        search += "periférica.";
                        break;
                }
            }


            if (filterForm["metadata"]["speaker_genre"]) {
                search += "\n\t+ Buscando en conversaciones en las que aperezca un hablante ";
                search += filterForm["metadata"]["speaker_genre"] === "H" ? "hombre." : "mujer.";
            }


            if (filterForm["metadata"]["speaker_educational_level"]) {
                search += "\n\t+ Buscando en conversaciones con hablantes de nivel educativo ";
                switch (filterForm["metadata"]["speaker_educational_level"]["cod"]) {
                    case "cod_high_level":
                        search += "alto.";
                        break;
                    case "cod_medium_level":
                        search += "medio.";
                        break;
                    case "cod_primary_level":
                        search += "bajo.";
                        break;
                    case "cod_unknown":
                        search += "desconocido.";
                        break;
                }
            }


            if (filterForm["metadata"]["speaker_age_range"]) {
                search += "\n\t+ Buscando en conversaciones con hablantes ";
                switch (filterForm["metadata"]["speaker_age_range"]["cod"]) {
                    case "cod_age_range_1":
                        search += "de edades comprendidas entre los 18 y 34 años.";
                        break;
                    case "cod_age_range_2":
                        search += "de edades comprendidas entre los entre 35 y 54 años.";
                        break;
                    case "cod_age_range_3":
                        search += "de más de 55 años.";
                        break;
                }
            }


            if (filterForm["metadata"]["speaker_age_range_2"]) {
                search += "\n\t+ Buscando en conversaciones con hablantes ";
                switch (filterForm["metadata"]["speaker_age_range_2"]["cod"]) {
                    case "cod_age_range_2_1":
                        search += "de edades comprendidas entre los 18 y 34 años.";
                        break;
                    case "cod_age_range_2_2":
                        search += "de edades comprendidas entre los entre 35 y 64 años.";
                        break;
                    case "cod_age_range_2_3":
                        search += "de más de 64 años.";
                        break;
                }
            }

            // Format units filter
            var toneFilter = "";
            if (filterForm["prosody"]["tone_ascending"]) {
                toneFilter += "ascendente, ";
            }
            if (filterForm["prosody"]["tone_descending"]) {
                toneFilter += "descendente, ";
            }
            if (filterForm["prosody"]["tone_suspended"]) {
                toneFilter += "suspendido, ";
            }
            if (filterForm["prosody"]["tone_circumflex"]) {
                toneFilter += "circunflejo, ";
            }
            if (!this.$mout.lang.isEmpty(toneFilter)) {
                //                    console.log(toneFilter);
                toneFilter = this.$mout.string.rtrim(toneFilter, ", ");

                search += "\n\t+ Entonación de tipo " + toneFilter + ".";
            }


            var subactTypeFilter = "";
            if (filterForm["units"]["subactsSAX"]) {
                subactTypeFilter += "SAX, ";
            }
            if (filterForm["units"]["subactsSAT_M"]) {
                subactTypeFilter += "SAT_M, ";
            }
            if (filterForm["units"]["subactsSAT_I"]) {
                subactTypeFilter += "SAT_I, ";
            }
            if (filterForm["units"]["subactsSAM_T"]) {
                subactTypeFilter += "SAM_T, ";
            }
            if (filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI, ";
            }
            if (filterForm["units"]["subactsSAI_T"]) {
                subactTypeFilter += "SAI_T, ";
            }
            if (filterForm["units"]["subactsSSX"]) {
                subactTypeFilter += "SSX, ";
            }
            if (filterForm["units"]["subactsSAM_I"]) {
                subactTypeFilter += "SAM_I, ";
            }
            if (filterForm["units"]["subactsSAI_M"]) {
                subactTypeFilter += "SAI_M, ";
            }
            if (filterForm["units"]["subactsSS_SSA"]) {
                subactTypeFilter += "SS_SA, ";
            }
            if (filterForm["units"]["residue"]) {
                subactTypeFilter += "residue,";
            }
            if (filterForm["units"]["subactsSSS"]) {
                subactTypeFilter += "SSS, ";
            }
            if (filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI, ";
            }
            if (filterForm["units"]["subactsSAM"]) {
                subactTypeFilter += "SAM, ";
            }
            if (filterForm["units"]["subactsSS_SA"]) {
                subactTypeFilter += "SS_SA, ";
            }
            if (filterForm["units"]["subactsSSTop"]) {
                subactTypeFilter += "SSS_Top, ";
            }
            if (filterForm["units"]["subactsSAT"]) {
                subactTypeFilter += "SAT, ";
            }
            if (filterForm["units"]["subactsSSD"]) {
                subactTypeFilter += "SSD, ";
            }
            if (!this.$mout.lang.isEmpty(subactTypeFilter)) {
                //                    console.log(subactTypeFilter)
                subactTypeFilter = this.$mout.string.rtrim(subactTypeFilter, ", ");

                search += "\n\t+ Buscando subactos de tipo: " + subactTypeFilter + ".";
            }

            var interventionTypeFilter = "";
            if (filterForm["units"]["initiative"]) {
                interventionTypeFilter += "independiente, ";
            }
            if (filterForm["units"]["reactive"]) {
                interventionTypeFilter += "reactiva, ";
            }
            if (filterForm["units"]["reactive_initiative"]) {
                interventionTypeFilter += "reactiva_iniciativa, ";
            }
            if (filterForm["units"]["independent"]) {
                interventionTypeFilter += "independiente,";
            }
            if (!this.$mout.lang.isEmpty(interventionTypeFilter)) {
                interventionTypeFilter = this.$mout.string.rtrim(interventionTypeFilter, ", ");

                search += "\n\t+ Buscando intervenciones de tipo: " + interventionTypeFilter + ".";
            }

            return search;
        },
        getSearchHtmlSummary(filterForm) {
            var search;

            search = "<h4>Filtros de búsqueda:</h4>";

            search += "<ul>";

            // Format options filter
            if (filterForm["options"]["token_mode"]) {
                search += "<li>";
                search += "Buscando por " + (filterForm["options"]["token_mode"] === "shape" ? "forma" : "lema");
                search += filterForm["options"]["capital_mode"] ? " teniendo en cuenta mayúsculas" : "";
                search += (filterForm["options"]["capital_mode"] && filterForm["options"]["accents"]) ? " y" : "";
                search += (filterForm["options"]["accents"]) ? " teniendo en cuenta acentos" : "";
                search += "</li>";
            }

            if (filterForm["options"]["filter_position"]) {
                search += "<li>";
                search += "Aparece ";
                switch (filterForm["options"]["filter_position"]) {
                    case "preceded":
                        search += "precedido";
                        break;
                    case "followed":
                        search += "seguido";
                        break;
                    case "both":
                        search += "precedido y seguido";
                        break;
                }

                search += " por "

                if (filterForm["options"]["filter_position_char"]) {
                    switch (filterForm["options"]["filter_position_char"]) {
                        case "exclamation_mark":
                            search += "¡!";
                            break;
                        case "question_marks":
                            search += "¿?";
                            break;
                        case "slash":
                            search += "/";
                            break;
                    }
                }
                search += "</li>";
            }


            if (filterForm["options"]["word_type"]) {
                search += "<li>";
                search += "Clase de palabra: " + filterForm["options"]["word_type"] + ".";
                search += "</li>";
            }

            if (filterForm["options"]["type"]) {
                search += "<li>";
                search += "De tipo: " + filterForm["options"]["type"] + ".";
                search += "</li>";
            }


            if (filterForm["options"]["subtype"]) {
                search += "<li>";
                search += "De subtipo: " + filterForm["options"]["subtype"] + ".";
                search += "</li>";
            }

            if (filterForm["options"]["person"]) {
                search += "<li>";
                search += "Persona: " + filterForm["options"]["person"] + ".";
                search += "</li>";
            }

            if (filterForm["options"]["genre"]) {
                search += "<li>";
                search += "Con género: " + filterForm["options"]["genre"] + ".";
                search += "</li>";
            }

            if (filterForm["options"]["number"]) {
                search += "<li>";
                search += "Con número: " + filterForm["options"]["number"] + ".";
                search += "</li>";
            }

            if (filterForm["options"]["mood"]) {
                search += "<li>";
                search += "De modo: " + filterForm["options"]["mood"] + ".";
                search += "</li>";
            }


            // Format metadata filter
            if (filterForm["metadata"]["conversation"]) {
                const conversation = this.conversations.filter((conversation) => {
                    return conversation["cod"] === filterForm["metadata"]["conversation"];
                });

                search += "<li>";
                if (conversation && conversation[0]) {
                    search += "Buscando en la conversación " + conversation[0]["name"] + ".";
                } else {
                    search += "Buscando en la conversación " + filterForm["metadata"]["conversation"] + ".";
                }
                search += "</li>";

            }

            if (filterForm["metadata"]["conversation_type"]) {
                search += "<li>";
                search += "Buscando en conversaciones de tipo ";
                switch (filterForm["metadata"]["conversation_type"]) {
                    case "cod_prototypical":
                        search += "prototípica.";
                        break;
                    case "cod_periferical":
                        search += "periférica.";
                        break;
                }
                search += "</li>";
            }

            if (filterForm["metadata"]["conv_year_init"] && filterForm["metadata"]["conv_year_end"]) {
                search += "<li>";
                search += "Conversaciones grabadas entre el " + filterForm["metadata"]["conv_year_init"];
                search += " y el " + filterForm["metadata"]["conv_year_end"] + ".";
                search += "</li>";
            }

            if (filterForm["metadata"]["speaker_genre"]) {
                search += "<li>";
                search += "Buscando en conversaciones en las que aperezca un hablante ";
                search += filterForm["metadata"]["speaker_genre"] === "H" ? "hombre." : "mujer.";
                search += "</li>";
            }


            if (filterForm["metadata"]["speaker_educational_level"]) {
                search += "<li>";
                search += "Buscando en conversaciones con hablantes de nivel educativo ";
                switch (filterForm["metadata"]["speaker_educational_level"]["cod"]) {
                    case "cod_high_level":
                        search += "alto.";
                        break;
                    case "cod_medium_level":
                        search += "medio.";
                        break;
                    case "cod_primary_level":
                        search += "bajo.";
                        break;
                    case "cod_unknown":
                        search += "desconocido.";
                        break;
                }
                search += "</li>";
            }


            if (filterForm["metadata"]["speaker_age_range"]) {
                search += "<li>";
                search += "Buscando en conversaciones con hablantes ";
                switch (filterForm["metadata"]["speaker_age_range"]["cod"]) {
                    case "cod_age_range_1":
                        search += "de edades comprendidas entre los 18 y 34 años.";
                        break;
                    case "cod_age_range_2":
                        search += "de edades comprendidas entre los entre 35 y 54 años.";
                        break;
                    case "cod_age_range_3":
                        search += "de más de 55 años.";
                        break;
                }
                search += "</li>";
            }


            if (filterForm["metadata"]["speaker_age_range_2"]) {
                search += "<li>";
                search += "Buscando en conversaciones con hablantes ";
                switch (filterForm["metadata"]["speaker_age_range_2"]["cod"]) {
                    case "cod_age_range_2_1":
                        search += "de edades comprendidas entre los 18 y 34 años.";
                        break;
                    case "cod_age_range_2_2":
                        search += "de edades comprendidas entre los entre 35 y 64 años.";
                        break;
                    case "cod_age_range_2_3":
                        search += "de más de 64 años.";
                        break;
                }
                search += "</li>";
            }

            // Format units filter
            var toneFilter = "";
            if (filterForm["prosody"]["tone_ascending"]) {
                toneFilter += "ascendente, ";
            }
            if (filterForm["prosody"]["tone_descending"]) {
                toneFilter += "descendente, ";
            }
            if (filterForm["prosody"]["tone_suspended"]) {
                toneFilter += "suspendido, ";
            }
            if (filterForm["prosody"]["tone_circumflex"]) {
                toneFilter += "circunflejo, ";
            }
            if (!this.$mout.lang.isEmpty(toneFilter)) {
                search += "<li>";
                //                    console.log(toneFilter);
                toneFilter = this.$mout.string.rtrim(toneFilter, ", ");

                search += "Entonación de tipo " + toneFilter + ".";
                search += "</li>";
            }


            var subactTypeFilter = "";
            if (filterForm["units"]["subactsSAX"]) {
                subactTypeFilter += "SAX, ";
            }
            if (filterForm["units"]["subactsSAT_M"]) {
                subactTypeFilter += "SAT_M, ";
            }
            if (filterForm["units"]["subactsSAT_I"]) {
                subactTypeFilter += "SAT_I, ";
            }
            if (filterForm["units"]["subactsSAM_T"]) {
                subactTypeFilter += "SAM_T, ";
            }
            if (filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI, ";
            }
            if (filterForm["units"]["subactsSAI_T"]) {
                subactTypeFilter += "SAI_T, ";
            }
            if (filterForm["units"]["subactsSSX"]) {
                subactTypeFilter += "SSX, ";
            }
            if (filterForm["units"]["subactsSAM_I"]) {
                subactTypeFilter += "SAM_I, ";
            }
            if (filterForm["units"]["subactsSAI_M"]) {
                subactTypeFilter += "SAI_M, ";
            }
            if (filterForm["units"]["subactsSS_SSA"]) {
                subactTypeFilter += "SS_SA, ";
            }
            if (filterForm["units"]["residue"]) {
                subactTypeFilter += "residue,";
            }
            if (filterForm["units"]["subactsSSS"]) {
                subactTypeFilter += "SSS, ";
            }
            if (filterForm["units"]["subactsSAI"]) {
                subactTypeFilter += "SAI, ";
            }
            if (filterForm["units"]["subactsSAM"]) {
                subactTypeFilter += "SAM, ";
            }
            if (filterForm["units"]["subactsSS_SA"]) {
                subactTypeFilter += "SS_SA, ";
            }
            if (filterForm["units"]["subactsSSTop"]) {
                subactTypeFilter += "SSS_Top, ";
            }
            if (filterForm["units"]["subactsSAT"]) {
                subactTypeFilter += "SAT, ";
            }
            if (filterForm["units"]["subactsSSD"]) {
                subactTypeFilter += "SSD, ";
            }
            if (!this.$mout.lang.isEmpty(subactTypeFilter)) {
                search += "<li>";
                //                    console.log(subactTypeFilter)
                subactTypeFilter = this.$mout.string.rtrim(subactTypeFilter, ", ");

                search += "Buscando subactos de tipo: " + subactTypeFilter + ".";
                search += "</li>";
            }

            var interventionTypeFilter = "";
            if (filterForm["units"]["initiative"]) {
                interventionTypeFilter += "independiente, ";
            }
            if (filterForm["units"]["reactive"]) {
                interventionTypeFilter += "reactiva, ";
            }
            if (filterForm["units"]["reactive_initiative"]) {
                interventionTypeFilter += "reactiva_iniciativa, ";
            }
            if (filterForm["units"]["independent"]) {
                interventionTypeFilter += "independiente,";
            }
            if (!this.$mout.lang.isEmpty(interventionTypeFilter)) {
                search += "<li>";
                interventionTypeFilter = this.$mout.string.rtrim(interventionTypeFilter, ", ");

                search += "Buscando intervenciones de tipo: " + interventionTypeFilter + ".";
                search += "</li>";
            }

            search += "</ul>";

            return search;
        },
        nextColumn(current) {
            let alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
            return alphabet[alphabet.indexOf(current) + 1];
        },
        async downloadBlob(blob, filename) {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename;

            document.body.appendChild(link);
            link.click()
            document.body.removeChild(link);
        },
        async loadConversation(conversationName) {
            var queryString;
            var conversation;

            this.conversation_loading = true;

            queryString = "fields=name";

            // Get all conversations
            conversation = await api.getAllItems("conversations", conversationName, queryString);

            return conversation[0];
        }
    }
};
</script>
<style scoped>
.selected {
    background-color: #fde19a !important;
}

.directSpeech tr {
    background-color: #8fbc8f5c !important;
}

.directSpeech .interv-contents {
    font-style: italic;
}

.observation {
    background-color: #d6e7ea !important;
}


.search-label-col {
    padding: 4px !important;
    padding-top: 8px !important;
}

.search-value-col {
    padding: 4px !important;
}

.v-input__slot {
    min-height: 30px !important;
}

.v-input--selection-controls {
    margin-top: 0px;
}

.headline {
    display: block;
    font-family: 'amaranth' !important;
    text-shadow: 1px 1px 1px #eaf1ea !important;
    line-height: 120% !important;
}

.filter-color {
    background-color: #FFF8E1 !important;
}

.filter-row-color {
    background-color: #FFE082 !important;
}

/*    .section-option i,span{
            color: #da8d2b;
        }*/

.section-title {
    padding: 0 0 20px 20px;
    line-height: 120%;
}

/*    .section-content{
            padding: 0 0 20px 20px;
            text-align: justify;
        }*/

.v-subheader {
    /*line-height: 50px !important;*/
    font-size: medium !important;
    /*font-weight: bold !important;*/
    color: black !important;
}

.v-tabs {
    height: 40px !important;
}

.v-expansion-panel-content__wrap {
    padding: 0 12px 12px;
}

.highlightText {
    color: darkorchid;
    /*background: yellow;*/
}

.context-axis {
    background: #ccccff;
    /*background: yellow;*/
}

.v-data-table td {
    padding: 0 10px;
}

.v-data-table td p {
    margin: 3px 0;
}

.v-data-table td i {
    font-weight: 300;
}

.speaker_turn_count {
    color: #e95e38;
    font-size: 95%;
}

.speaker_key {
    color: black;
}

.speaker_int_count {
    color: cornflowerblue;
    font-size: 95%;
}

.v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
}

.v-data-table td {
    padding: 0 4px;
    margin: 0 !important;
}

#filter-summary-panel {
    padding-top: 0px;
    padding-bottom: 0px;
}

#filter-summary-panel h4 {
    margin-top: 0px;
}
</style>
